import Form, { FieldDefinition, FormData, FormDefinition } from "../../Components/Form/Form";
import LoadingIndicator from "../../Components/LoadingIndicator";
import { getRegionalMembershipId, getUserProfile, setCommonSettings, updateUserProfile } from "../../services/userService";
import { AuthContext, AuthContextType, ConditionalRenderContext, ConditionalRenderContextType, LangContext, LangContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync} from "../../utilities/customHooks";
import * as T from "../../utilities/frontendTypes";
import { Address } from "../../Components/Form/AddressFields";

import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import Button, { ButtonProp } from "../../Components/Button";
import { createFounderApplication, getLatestMembershipApplication, editedApplicationChange } from "../../services/founderService";
import { flattenObject, getModifiedCompanyInfoFormDef, getUserLanguage, handleFormSaveResponse, returnLangCheckedFormGroupDef } from "../../utilities/helperFunctions";
import Tooltip from "../../Components/Tooltip";
import ErrorIndicator from "../../Components/ErrorIndicator";
import _ from 'underscore';
import Modal from "../../Components/Modal";
import textData from "../../textData.json";
import FileUpload from  "../../Components/Form/pdfUpload"
import { needHelpWithDefinition, profileFormCompanyInfoDefinition, profileFormPersonalInfoDefinition, profileFormProgramingEvaluationDefinition, profileFormiPStrategyDefinition, profileFormipReadinessDefinition} from "../../utilities/profileFormDefitions"
import DatePicker from 'react-datepicker';
import { basic_text_validator, multiselect_validator, selection_validator, url_validator } from "../../utilities/formFieldValidators";
import moment from "moment";

function FounderProfileUpdated() {
  const { langState } = useContext(LangContext) as LangContextType
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const { memberApplicationStatus, setMemberApplicationStatus } = useContext(AuthContext) as AuthContextType; 
  const navigate = useNavigate();
  const conditionalRenderContext = useContext(ConditionalRenderContext) as ConditionalRenderContextType;
  const [founderProfile, setFounderProfile] = useState<T.StartupFounderProfile | null>(null);
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const [isEditing, setIsEditing] = useState(false);
  const [isAttestaionChecked, setIsAttestaionChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateTier, setUpdateTier] = useState(false)
  const [progressHTML, setProgressHTML] = useState<React.ReactNode | null>(null);
  const [currentHTML, setCurrentHTML] = useState<FounderProfileSectionKey>("personalInfo")
  const [pdfUploaded, setPdfUploaded] = useState(false);
  const [pdfSaved, setPdfSaved] = useState(false);
  const { isAuthenticated, userRole, settings, logout, setSettings } = useContext(AuthContext) as AuthContextType; // [NOTE] This casting is intentional
  //FORM STATES
  const [personalInfo, setPersonalInfo] = useState<T.PersonalInfo | null>(null)
  const [companyInfo, setCompanyInfo] = useState<T.CompanyInfo | null>(null)
  const [IPStrategy, setIPStrategy] = useState<T.IPStrategy | null>(null)
  const [ipReadiness, setIPReadiness] = useState<T.IPReadiness | null>(null)
  const [needHelpWith, setNeedHelpWith] = useState<T.NeedHelpWith | null>(null)
  const [programingEvaluation, setProgramingEvaluation] = useState<T.ProgramingEvaluation | null>(null)
  const [pitchDeck, setPitchDeck] = useState(false)
  //FORM COMPLETENESS
  const [personalInfoComplete, setPersonalInfoComplete] = useState<FormCompletnessState>("incomplete")
  const [companyInfoComplete, setCompanyInfoComplete] = useState<FormCompletnessState>("incomplete")
  const [pitchDeckComplete, setPitchDeckComplete] = useState<FormCompletnessState>("incomplete")
  const [programingEvaluationComplete, setProgramingEvaluationComplete] = useState<FormCompletnessState>("incomplete")
  const [needHelpWithComplete, setNeedHelpWithComplete] = useState<FormCompletnessState>("incomplete")
  const [mailingAddress, setMailingAddress] = useState<any>(null)
  //COMPANYINFOSTATES
  const [companyName, setCompanyName] = useState("")
  const [companyInfoStateObj, setCompanyInfoStateObj] = useState<{ [key: string]: any }>({});
  const [needHelpWithStateObj, setNeedHelpWithStateObj] = useState<{ [key: string]: any }>({});
  const [requireIndusrtyOther, setRequireIndusrtyOther] = useState(false)
  const [tech, setTech] = useState<string[]>([]);
  const [requireTechOther, setRequireTechOther] = useState(false)
  const [revFromTech, setRevFromTech] = useState<boolean | null>(null)
  const [regDate, setRegDate] = useState<Date | null>(null)
  const [provincialRegistered, setProvincialRegistered] = useState<boolean | null>(null)
  const [federalRegistered, setFederalRegistered] = useState<boolean | null>(null)
  const [province, setProvince] = useState<string[]>([]);
  const [errorArray, setErrorArray] = useState<string[]>([]);
  const [bnNotNine, setBnNotNine] = useState(false)
  //NEDHELPSTATES
  const [seekingEducation, setSeekingEducation] = useState<boolean | null>(null)
  const [businessGoal, setBusinessGoal] = useState<boolean | null>(null)
  const [agreementSigned, setAgreementSigned] = useState<boolean | null>(null)
  const [workingWithFirm, setWorkingWithFirm] = useState<boolean | null>(null)
  const [govtSupport, setGovtSupport] = useState<boolean | null>(null)
  const [topics, setTopics] = useState<string[]>([]);
  const [desiredActivities, setDesiredActivities] = useState<string[]>([]);
  const [requireDesiredActivitesOther, setRequireDesiredActivitesOther] = useState(false)  
  const [patentActivities, setPatentActivities] = useState<string[]>([]);
  const [requirePatentActivitiesOther, setRequirePatentActivitiesOther] = useState(false)  
  const [patentsReadyOptions, setPatentsReadyOptions] = useState<string[]>([]);
  const [regionalFirmOptions, setRegionalFirmOptions] = useState<{value: string, text: string, frText: string}[]>([])
  const [requireFirmOther, setRequireFirmOther] = useState(false)  
  const [requireSupportOrgOther, setRequireSupportOrgOther] = useState(false)  
  const [reviewHtml, setReviewHtml] = useState(<></>)
  const [datePickerHtml, setDatePickerHtml] = useState(<></>)
  const [submittedSectionError, setSubmittedSectionError] = useState(false)  

  
  useEffect(() => {
    setDatePickerHtml(
    <DatePicker 
      className={" w-full text-text bg-background !border-cSecondaryGreen input"}
      id={"date"}
      selected={regDate === null ? undefined : regDate}
      scrollableYearDropdown={true}
      showYearDropdown
      yearDropdownItemNumber={115}
      onChange={handleRegDateChange}
      maxDate={new Date()}
  />
    )
  }, [regDate])

  const getNeedHelpFormDef = () => {
    const regionalFirmSelectionData = () => {
      const array: {value: string, text: string, frText: string}[] = []
      regionalFirmOptions.forEach((item) => (
        array.push(
          {value: item.value, 
          text: item.text, 
          frText: item.text
          }
        )
      ))
      array.push({value: "Other", text: "Other", frText: "Autre"})
      return array
    }
    
    let modifiedForm = { ...needHelpWithDefinition };
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "topics";
      const newValue: FieldDefinition = {
          label: "Please select the topics that you'd like to discuss with our IP Advisor:",
          frLabel: "",
          inputType: "multiSelect",
          validator: selection_validator,
          conditionalRenderDefinition: {
            fieldKey: "businessGoal",
            renderWhenTrue: true, 
          },
          additionalData: {
            selectionData: [
              {
                value: "Patents",
                text: "Patents",
                frText: "",
              },
              {
                value: "Industrial Designs/ Design Patents",
                text: "Industrial Designs/ Design Patents",
                frText: "",
              },
              {
                value: "Trademarks",
                text: "Trademarks",
                frText: "",
              },
              {
                value: "Trade Secrets",
                text: "Trade Secrets",
                frText: "",
              },
              {
                value: "Copyright",
                text: "Copyright",
                frText: "",
              },
              {
                value: "Open Source Asset Use",
                text: "Open Source Asset Use",
                frText: "",
              },
              {
                value: "IP Strategy",
                text: "IP Strategy",
                frText: "",
              },
              {
                value: "IP Ownership",
                text: "IP Ownership",
                frText: "",
              },
              {
                value: "Freedom to Operate",
                text: "Freedom to Operate",
                frText: "",
              },
            ]
          },
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "businessGoal") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }
    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.businessGoal && founderProfile.needHelpWith.topics) {
      const newKey = "specificDiscussion";
      const newValue: FieldDefinition = {
        label: "Without specifically referencing IP sensitive information, please provide a general overview of what you' like to discuss with our IP Advisor",
        frLabel: "",
        inputType: "textarea",
        conditionalRenderDefinition: {
          fieldKey: "businessGoal",
          renderWhenTrue: true, 
        },
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "topics") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.desiredActivities.includes("Other")) {
      const newKey = "activitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "desiredActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Other")) {
      const newKey = "patentActivitiesOther";
      const newValue: FieldDefinition = {
        label: "Please specify",
        frLabel: "Veuillez préciser",
        inputType: "text",
        validator: basic_text_validator  
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.length > 0 && founderProfile.needHelpWith.exclusiveRights) {
      const newKey = "exclusiveRights";
      const newValue: FieldDefinition = {
        label: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
        frLabel: "If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "yes",
              text: "Yes",
              frText: "Oui",
            },
            {
              value: "no",
              text: "No",
              frText: "Non",
            },
            {
              value: "n/a",
              text: "N/A",
              frText: "N/A",
            }
          ]
        },     
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Trademark Filing")) {
      const newKey = "searchCompleted";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        frLabel: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        inputType: "dropdownSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "yes",
              text: "Yes",
              frText: "Oui",
            },
            {
              value: "no",
              text: "No",
              frText: "Non",
            },
            {
              value: "n/a",
              text: "N/A",
              frText: "N/A",
            }
          ]
        },     
      };
  
      const newForm: FormDefinition = {};
      for (const [key, value] of Object.entries(modifiedForm)) {
        newForm[key] = value;
        if (key === "patentActivities") {
          newForm[newKey] = newValue;
        }
      }
      modifiedForm = newForm;
    }

    if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.patentActivities.includes("Patent Filing")) {
      const newKey = "patentsReadyOptions";
      const newValue: FieldDefinition = {
        label: "If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:",
        frLabel: "",
        inputType: "multiSelect",
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              frText: "",
            },
            {
              value: "I have a granted patent in the same patent family.",
              text: "I have a granted patent in the same patent family.",
              frText: "",
            },
            {
              value: "I have received a favorable written opinion from my PCT application.",
              text: "I have received a favorable written opinion from my PCT application.",
              frText: "",
            },
            {
              value: "None of the Above",
              text: "None of the Above",
              frText: "",
            }
          ]
        },
      };
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "patentActivities") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm) {
        const newKey = "firmId";
        const newValue: FieldDefinition = {
          label: `Please select the firm (select "Other" if your current firm is not listed)`,
          frLabel: "",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: regionalFirmSelectionData()
          },
          };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "workingWithFirm") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.workingWithFirm && founderProfile.needHelpWith.firmId === "Other" && founderProfile.needHelpWith.firmOther) {
        const newKey = "firmOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator    
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "firmId") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport) {
        const newKey = "supportOrg";
        const newValue: FieldDefinition = {
          label: `Please select which organization:`,
          frLabel: "Veuillez préciser quelle organisation:",
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "Intellectual Property Ontario (IPON)",
                text: "Intellectual Property Ontario (IPON)",
                frText: "",
              },
              {
                value: "IP Assist",
                text: "IP Assist",
                frText: "",
              },
              {
                value: "Other",
                text: "Other",
                frText: "",
              }
            ]
          },     
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "govtSupport") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

      if (founderProfile && founderProfile.needHelpWith && founderProfile.needHelpWith.govtSupport && founderProfile.needHelpWith.supportOrg === "Other" && founderProfile.needHelpWith.supportOrgOther) {
        const newKey = "supportOrgOther";
        const newValue: FieldDefinition = {
          label: "Please specify",
          frLabel: "Veuillez préciser",
          inputType: "text",
          validator: basic_text_validator        
        };
    
        const newForm: FormDefinition = {};
        for (const [key, value] of Object.entries(modifiedForm)) {
          newForm[key] = value;
          if (key === "supportOrg") {
            newForm[newKey] = newValue;
          }
        }
        modifiedForm = newForm;
      }

    return modifiedForm
  }

  useEffect(() => {
    setReviewHtml(
    <div className="w-full flex flex-col">
    <div className="flex flex-col">
      {memberApplicationStatus === "pendingEditRequest" ?
      <div className="w-full flex flex-col gap-4">
        <h3 className="">{textData.Pages.FounderPages.FounderProfile.RevEdit[langState]}</h3>
        <p className="bodyLarger mb-8">{textData.Pages.FounderPages.FounderProfile.RevSubEdit[langState]}</p>
      </div>
      :
      <div className="w-full flex flex-col gap-4">
        <h3 className="">{textData.Pages.FounderPages.FounderProfile.Rev[langState]}</h3>
        <p className="bodyLarger mb-8">{textData.Pages.FounderPages.FounderProfile.RevSub[langState]}</p>
      </div>
      }
    </div>
    <div className="flex flex-col applicationFormWidth">
      <h4 className="mb-6">{textData.Pages.FounderPages.FounderProfile.YourInfo[langState]}</h4>
      <Form
        formDefinition={profileFormPersonalInfoDefinition}
        formData={founderProfile && founderProfile.personalInfo ? founderProfile.personalInfo : null}
        readOnly
        modifierFunc={personalFormModifier}
        disabled
      />
      <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.CompanyInfo[langState]}</h4>
      {founderProfile &&
      <Form
        formDefinition={getModifiedCompanyInfoFormDef(founderProfile)}
        formData={founderProfile && founderProfile.companyInfo ? companyInfoToForm(founderProfile.companyInfo) : null}
        readOnly
        disabled
      />
      }
      <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.HelpWith[langState]}</h4>
      <Form
        formDefinition={getNeedHelpFormDef()}
        formData={founderProfile && founderProfile.needHelpWith ? founderProfile.needHelpWith : null}
        readOnly
        disabled
      />
      <h4 className="mb-6 mt-8">{textData.Pages.FounderPages.FounderProfile.ServiceEval[langState]}</h4>
      <Form
        formDefinition={profileFormProgramingEvaluationDefinition}
        formData={founderProfile && founderProfile.programingEvaluation ? founderProfile.programingEvaluation : null}
        readOnly
        disabled
      />
      <div className="mt-8">
        <Button
          actionHandler={modalProfileCheck}
          buttonText={textData.Pages.FounderPages.FounderProfile.SubmitApp[langState]}
          buttonType="primaryFull"
          disabled={memberApplicationStatus === "pending" || memberApplicationStatus === "flagged" || memberApplicationStatus === "rejected" || memberApplicationStatus === "approved"}
        />
      </div>
    </div>
  </div>
    )
  }, [memberApplicationStatus, programingEvaluation, companyInfo, personalInfo, founderProfile])

  type FormCompletnessState = "complete" | "incomplete" 

  const techOptions = [
    { value: "Advanced Energy Technology", text: "Advanced Energy Technology" },
    { value: "Advanced Materials and Manufacturing", text: "Advanced Materials and Manufacturing" },
    { value: "Advanced Sensing and Surveillance", text: "Advanced Sensing and Surveillance" },
    { value: "Advanced Digital Infrastructure", text: "Advanced Digital Infrastructure" },
    { value: "Advanced Weapons", text: "Advanced Weapons" },
    { value: "Aerospace, Space and Satellite", text: "Aerospace, Space and Satellite" },
    { value: "Artificial Intelligence and Big Data", text: "Artificial Intelligence and Big Data" },
    { value: "Human-Machine Integration", text: "Human-Machine Integration" },
    { value: "Life Science", text: "Life Science" },
    { value: "Quantum Science", text: "Quantum Science" },
    { value: "Robotics and Autonomous Systems", text: "Robotics and Autonomous Systems" },
    { value: "Securetech", text: "Securetech" },
    { value: "Other", text: "Other" },
  ];

  const provinceOptions = [
      {value: "AB", text: "Alberta", frText: "Alberta"},
      { value: "BC", text: "British Columbia", frText: "Colombie-Britannique" },
      { value: "MB", text: "Manitoba", frText: "Manitoba" },
      { value: "NB", text: "New Brunswick", frText: "Nouveau-Brunswick" },
      { value: "NL", text: "Newfoundland and Labrador", frText: "Terre-Neuve-et-Labrador" },
      { value: "NT", text: "Northwest Territories", frText: "Territoires du Nord-Ouest" },
      { value: "NS", text: "Nova Scotia", frText: "Nouvelle-Écosse" },
      { value: "NU", text: "Nunavut", frText: "Nunavut" },
      { value: "ON", text: "Ontario", frText: "Ontario" },
      { value: "PE", text: "Prince Edward Island", frText: "Île-du-Prince-Édouard" },
      { value: "QC", text: "Quebec", frText: "Québec" },
      { value: "SK", text: "Saskatchewan", frText: "Saskatchewan" },
      { value: "YT", text: "Yukon", frText: "Yukon" }
  ];

  const topicsOptions = [
    { value: "Patents", text: "Patents", frText: "Patents" },
    { value: "Industrial Designs/ Design Patents", text: "Industrial Designs/ Design Patents", frText: "Dessins industriels / brevets de design" },
    { value: "Trademarks", text: "Trademarks", frText: "Marques de commerce" },
    { value: "Trade Secrets", text: "Trade Secrets", frText: "Secrets commerciaux" },
    { value: "Copyright", text: "Copyright", frText: "Droit d'auteur" },
    { value: "Open Source Asset Use", text: "Open Source Asset Use", frText: "Utilisation d'actifs open source" },
    { value: "IP Strategy", text: "IP Strategy", frText: "Stratégie de PI" },
    { value: "IP Ownership", text: "IP Ownership", frText: "Propriété intellectuelle" },
    { value: "Freedom to Operate", text: "Freedom to Operate", frText: "Liberté d’exploitation" }
  ]

  const desiredActivitiesOptions = [
    { value: "IP Strategy", text: "IP Strategy", frText: "Stratégie de PI" },
    { value: "Invention/Patent Mining", text: "Invention/Patent Mining", frText: "Exploration d'inventions/de brevets" },
    { value: "Patentability/Novelty/Prior Art Search", text: "Patentability/Novelty/Prior Art Search", frText: "Recherche de brevetabilité/névérité/état de la technique" },
    { value: "Patent Landscape Report", text: "Patent Landscape Report", frText: "Rapport sur le paysage des brevets" },
    { value: "Trademark Clearance Search", text: "Trademark Clearance Search", frText: "Recherche de disponibilité de marque" },
    { value: "Trade Secret Protection Plan", text: "Trade Secret Protection Plan", frText: "Plan de protection des secrets commerciaux" },
    { value: "Other", text: "Other", frText: "Autre" }    
  ]

  const patentActivitiesOptions = [
    { value: "Patent Filing", text: "Patent Filing", frText: "Dépôt de brevet" },
    { value: "Patent Conversion", text: "Patent Conversion", frText: "Conversion de brevet" },
    { value: "Patent Prosecution", text: "Patent Prosecution", frText: "Procédure de délivrance de brevet" },
    { value: "Trademark Filing", text: "Trademark Filing", frText: "Dépôt de marque" },
    { value: "Licensing Agreement Review/Drafting", text: "Licensing Agreement Review/Drafting", frText: "Révision/rédaction d’un contrat de licence" },
    { value: "Design Patent/Industrial Design Application", text: "Design Patent/Industrial Design Application", frText: "Demande de brevet de design/dessin industriel" },
    { value: "Other", text: "Other", frText: "Autre" }       
  ]

  const patentsReadyOptionsOptions = [
    {
      value: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
      text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
      frText: "Mon prestataire de services de PI a effectué une recherche favorable de brevetabilité/de l'état de la technique/de nouveauté pour la technologie que je prévois de breveter.",
    },
    {
      value: "I have a granted patent in the same patent family.",
      text: "I have a granted patent in the same patent family.",
      frText: "Je détiens un brevet accordé dans la même famille de brevets.",
    },
    {
      value: "I have received a favorable written opinion from my PCT application.",
      text: "I have received a favorable written opinion from my PCT application.",
      frText: "J'ai reçu une opinion écrite favorable de ma demande PCT.",
    },
    {
      value: "None of the Above",
      text: "None of the Above",
      frText: "",
    }  ]

  const handlePdfStateChange = () => {
    setPdfUploaded(true);
  };

  const personalFormModifier = () => {
      const formConts = document.getElementsByClassName('formComponentCont');
      if (formConts.length > 0) {
          formConts[0].classList.add('blockFormCont');
      }
      if (formConts.length > 1) {
          formConts[1].classList.add('blockFormCont');
      }
    }

  const handleLangToggle = async () => {
    if (settings === null) {
      const tempLang = getUserLanguage() === "Fr-fr" ? "fr" : "eng";
      // const tempTheme = getIsOSDarkMode() ? "dark" : "light";
      setSettings({
        themeMode: "light",
        lang: tempLang
    })
    }

    const lang = langState === "eng" ? "fr" : "eng";

    const updatedSettings = { ...settings, lang } as T.Settings;
    setSettings(updatedSettings)

    showLoading();
    await setCommonSettings(updatedSettings);
    hideLoading();
  }

  useEffect(() => {
    if (errorArray.includes("govtSupport")) {
      setErrorArray(prev => prev.filter(item => item !== "govtSupport"));
    }
  }, [govtSupport])

  useEffect(() => {
    if (errorArray.includes("registeredFederally")) {
      setErrorArray(prev => prev.filter(item => item !== "registeredFederally"));
    }
  }, [federalRegistered])

  useEffect(() => {
    if (errorArray.includes("registeredProvincially")) {
      setErrorArray(prev => prev.filter(item => item !== "registeredProvincially"));
    }
  }, [provincialRegistered])

  useEffect(() => {
    if (errorArray.includes("seekingEducation")) {
      setErrorArray(prev => prev.filter(item => item !== "seekingEducation"));
    }
  }, [seekingEducation])

  useEffect(() => {
    if (errorArray.includes("businessGoal")) {
      setErrorArray(prev => prev.filter(item => item !== "businessGoal"));
    }
  }, [businessGoal])

  useEffect(() => {
    if (errorArray.includes("agreementSigned")) {
      setErrorArray(prev => prev.filter(item => item !== "agreementSigned"));
    }
  }, [agreementSigned])

  useEffect(() => {
    if (errorArray.includes("revFromTech")) {
      setErrorArray(prev => prev.filter(item => item !== "revFromTech"));
    }
  }, [revFromTech])

  useEffect(() => {
    if (errorArray.includes("tech") && tech.length > 0) {
      setErrorArray(prev => prev.filter(item => item !== "tech"));
    }
  }, [tech])
  

  useEffect(() => {
    if (errorArray.includes("workingWithFirm")) {
      setErrorArray(prev => prev.filter(item => item !== "workingWithFirm"));
    }
    if (workingWithFirm === false && errorArray.includes("firmId")) {
      console.log
      setErrorArray(prev => prev.filter(item => item !== "firmId"));
    }
    if (workingWithFirm === false && errorArray.includes("firmOther")) {
      setErrorArray(prev => prev.filter(item => item !== "firmOther"));
    }
  }, [workingWithFirm])


  // useEffect(() => {
  //   const sideMenu = document.getElementById("applicationSideMenuInner");
  //   const reviewButton = document.getElementById("reviewButton");

  //   if (sideMenu) {
  //     if (currentHTML === "review") {
  //       // Remove the element if it exists
  //       if (reviewButton) {
  //         sideMenu.removeChild(reviewButton);
  //       }
  //     } else {
  //       // Add the element if it doesn't exist
  //       if (!reviewButton) {
  //         const newButton = document.createElement("div");
  //         newButton.id = "reviewButton";
  //         newButton.className =
  //           memberApplicationStatus === "pending" ||
  //           memberApplicationStatus === "approved" ||
  //           personalInfoComplete === "incomplete" ||
  //           companyInfoComplete === "incomplete" ||
  //           pitchDeckComplete === "incomplete" ||
  //           programingEvaluationComplete === "incomplete"
  //             ? "hidden"
  //             : "";
  //         newButton.innerHTML = `
  //           <button 
  //             class=
  //             ${memberApplicationStatus === "pending" ||
  //             memberApplicationStatus === "rejected" ||
  //             programingEvaluationComplete !== "complete" ? "primaryButtonDisabled" : "primaryButton"}
  //           >
  //             ${textData.Pages.FounderPages.FounderProfile.Submit[langState]}
  //           </button>
  //         `;
  //         newButton.onclick = () => setCurrentHTML("review");

  //         sideMenu.appendChild(newButton);
  //       }
  //     }
  //   }
  // }, [currentHTML]);

  const htmlCheck = () => {
    if (personalInfoComplete === "incomplete") {
      setCurrentHTML("personalInfo")
    } else if (companyInfoComplete === "incomplete") {
      setCurrentHTML("companyInfo")
    } else if (pitchDeckComplete === "incomplete") {
      setCurrentHTML("pitchDeck")
    } else if (needHelpWithComplete === "incomplete") {
      setCurrentHTML("needHelpWith")
    } else if (programingEvaluationComplete === "incomplete") {
      setCurrentHTML("programingEvaluation")
    } else if (programingEvaluationComplete === "complete") {
      setCurrentHTML("review")
    } 
      else {
      setCurrentHTML("personalInfo")
      console.log("edge case")
    }
  }

  const incompleteCircle = <svg className="completeCircle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#F7F7F7"/></svg>
  const currentCircle = <svg className="completeCircle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#F8CE7D"/></svg>
  const completeCircle = <svg className="circle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clipPath="url(#clip0_2385_761)"><path d="M3 13.0148C3 14.4613 3.28491 15.8937 3.83846 17.23C4.392 18.5664 5.20335 19.7807 6.22617 20.8035C7.249 21.8263 8.46326 22.6377 9.79965 23.1912C11.136 23.7448 12.5684 24.0297 14.0148 24.0297C15.4613 24.0297 16.8937 23.7448 18.23 23.1912C19.5664 22.6377 20.7807 21.8263 21.8035 20.8035C22.8263 19.7807 23.6377 18.5664 24.1912 17.23C24.7448 15.8937 25.0297 14.4613 25.0297 13.0148C25.0297 11.5684 24.7448 10.136 24.1912 8.79965C23.6377 7.46326 22.8263 6.249 21.8035 5.22617C20.7807 4.20335 19.5664 3.392 18.23 2.83846C16.8937 2.28491 15.4613 2 14.0148 2C12.5684 2 11.136 2.28491 9.79965 2.83846C8.46326 3.392 7.249 4.20335 6.22617 5.22617C5.20335 6.249 4.392 7.46326 3.83846 8.79965C3.28491 10.136 3 11.5684 3 13.0148Z" fill="#EBF6F0"/><path d="M11.9992 23.0141C9.0779 23.0141 6.27623 21.8536 4.21055 19.7879C2.14486 17.7222 0.984375 14.9205 0.984375 11.9992C0.984375 9.0779 2.14486 6.27623 4.21055 4.21055C6.27623 2.14486 9.0779 0.984375 11.9992 0.984375V23.0141Z" fill="#F7F7F7"/><path d="M0.984375 11.9992C0.984375 13.4457 1.26928 14.878 1.82283 16.2144C2.37638 17.5508 3.18772 18.7651 4.21055 19.7879C5.23337 20.8107 6.44764 21.6221 7.78402 22.1756C9.1204 22.7292 10.5527 23.0141 11.9992 23.0141C13.4457 23.0141 14.878 22.7292 16.2144 22.1756C17.5508 21.6221 18.7651 20.8107 19.7879 19.7879C20.8107 18.7651 21.6221 17.5508 22.1756 16.2144C22.7292 14.878 23.0141 13.4457 23.0141 11.9992C23.0141 10.5527 22.7292 9.1204 22.1756 7.78402C21.6221 6.44764 20.8107 5.23337 19.7879 4.21055C18.7651 3.18773 17.5508 2.37638 16.2144 1.82283C14.878 1.26928 13.4457 0.984375 11.9992 0.984375C10.5527 0.984375 9.1204 1.26928 7.78402 1.82283C6.44764 2.37638 5.23337 3.18773 4.21055 4.21055C3.18772 5.23337 2.37638 6.44764 1.82283 7.78402C1.26928 9.1204 0.984375 10.5527 0.984375 11.9992Z" stroke="#1A2E25" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/><path d="M17.7477 7.21094L11.043 16.3102L6.25391 12.4789" stroke="#1A2E25" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_2385_761"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>

    //WHEN READY TO SUBMIT
    const modalProfileCheck = () => {
    
      if (!founderProfile) {
        handleSubmissionReject();
        return;
      }
  
      const {
        personalInfo, 
        pointOfContact, 
        companyInfo, 
        needHelpWith, 
        programingEvaluation, 
      } = founderProfile;
  
      if (!companyInfo) {
        handleSubmissionReject();
        return;
      }
  
      if(!pitchDeck) {
          handleSubmissionReject();
          return;
      }
  
      const { registration, 
              mailingAddress, 
              basicInfo } = companyInfo;
  
      if (
        personalInfo === null ||
        (!personalInfo.isPointOfContact && pointOfContact === null) || 
        basicInfo === null ||
        registration === null ||
        mailingAddress === null ||
        programingEvaluation === null || 
        needHelpWith === null
      ) {
        handleSubmissionReject();
        return;
      }
      setIsModalOpen(true)
    }
  
  type FounderProfileSectionKey = "personalInfo" | "companyInfo" | "pitchDeck" | "needHelpWith" |"iPStrategy" | "ipReadiness" | "programingEvaluation" | "review"
  

useEffect(() => {
    const top = document.getElementById("top") 
    if (top) {
      top.scrollIntoView({ behavior: 'auto' });
    }
  }, [currentHTML]);

  useEffect(() => {
    try {
      const fetchFounderProfile = async () => {
        showLoading();
        const founderProfileRes = await getUserProfile("startupFounder");
        hideLoading();
        if (founderProfileRes.userRegion !== "investOttawa") {
          navigate("/dashboard")
        }
        setCompanyName(founderProfileRes.username)
        if (founderProfileRes.regionalFirmOptions) {
          setRegionalFirmOptions(founderProfileRes.regionalFirmOptions)
        }
        const initialProfile = founderProfileRes.profile as T.StartupFounderProfile | null;
        setMailingAddress(initialProfile?.companyInfo?.mailingAddress)
        setFounderProfile(initialProfile);
        //FORM STATES
        if (initialProfile?.personalInfo) {
          setPersonalInfo(initialProfile.personalInfo)
          setPersonalInfoComplete("complete")
        }
        if (initialProfile?.companyInfo && initialProfile.companyInfo.basicInfo !== null && initialProfile.companyInfo.registration !== null && initialProfile.companyInfo.mailingAddress) {
          setCompanyInfo(initialProfile.companyInfo)
          setCompanyInfoStateObj({...initialProfile.companyInfo.basicInfo, ...initialProfile.companyInfo.registration})
          if (initialProfile.companyInfo.registration.date) {
            setRegDate(moment(initialProfile.companyInfo.registration.date).toDate())
          }
          if (initialProfile.companyInfo.registration.registeredFederally || initialProfile.companyInfo.registration.registeredFederally === false) {
            setFederalRegistered(initialProfile.companyInfo.registration.registeredFederally)
          }
          if (initialProfile.companyInfo.registration.registeredProvincially || initialProfile.companyInfo.registration.registeredProvincially === false) {
            setProvincialRegistered(initialProfile.companyInfo.registration.registeredProvincially)
          }
          if (initialProfile.companyInfo.registration.province) {
            setProvince(initialProfile.companyInfo.registration.province)
          }
          if (initialProfile.companyInfo.basicInfo.tech) {
            setTech(initialProfile.companyInfo.basicInfo.tech)
          }
          if (initialProfile.companyInfo.basicInfo.revFromTech === false || initialProfile.companyInfo.basicInfo.revFromTech) {
            setRevFromTech(initialProfile.companyInfo.basicInfo.revFromTech)
            
          }
          if (initialProfile.companyInfo.basicInfo.tech?.includes("Other")) {
            setRequireTechOther(true)
          }
          if (initialProfile.companyInfo.basicInfo.industry?.includes("Other")) {
            setRequireIndusrtyOther(true)
          }
          const techOtherBoolean = initialProfile.companyInfo.basicInfo.tech && initialProfile.companyInfo.basicInfo.tech.includes("Other") && initialProfile.companyInfo.basicInfo.techOther || initialProfile.companyInfo.basicInfo.tech && !initialProfile.companyInfo.basicInfo.tech.includes("Other") 
          const industryOtherBoolean = initialProfile.companyInfo.basicInfo.industry && initialProfile.companyInfo.basicInfo.industry.includes("Other") && initialProfile.companyInfo.basicInfo.industryOther || initialProfile.companyInfo.basicInfo.industry && !initialProfile.companyInfo.basicInfo.industry.includes("Other") 
          const provinceBoolean = initialProfile.companyInfo.registration.registeredProvincially && initialProfile.companyInfo.registration.province.length > 0 || initialProfile.companyInfo.registration.registeredProvincially === false 
          if (initialProfile.companyInfo.basicInfo.operatingName && initialProfile.companyInfo.basicInfo.legalName && initialProfile.companyInfo.basicInfo.description &&
            techOtherBoolean && industryOtherBoolean && initialProfile.companyInfo.basicInfo.websiteURL && initialProfile.companyInfo.basicInfo.techReadiness &&
            initialProfile.companyInfo.basicInfo.techReadiness && initialProfile.companyInfo.basicInfo.patentsGranted !== null && initialProfile.companyInfo.basicInfo.revFromTech !== null &&
            initialProfile.companyInfo.basicInfo.numFullTimeEmployeesCan !== null && initialProfile.companyInfo.basicInfo.numFullTimeEmployees !== null && initialProfile.companyInfo.basicInfo.revenueOverTwelveMonths !== null &&
            initialProfile.companyInfo.registration.date && initialProfile.companyInfo.registration.number && initialProfile.companyInfo.registration.registeredFederally !== null && provinceBoolean 
          ) {
            console.log("companyInfo is COmplete")
            setCompanyInfoComplete("complete")
          } else {
            console.log(initialProfile.companyInfo.basicInfo)
            console.log(initialProfile.companyInfo.registration)
            console.log(techOtherBoolean, industryOtherBoolean, provinceBoolean)
          }
        }
        if (initialProfile?.documents?.pitchdeck) {
          setPitchDeck(true)
          setPitchDeckComplete("complete")
        }
        if (initialProfile?.needHelpWith) {
          setNeedHelpWith(initialProfile.needHelpWith)
          setSeekingEducation(initialProfile.needHelpWith.seekingEducation)
          setBusinessGoal(initialProfile.needHelpWith.businessGoal)
          setTopics(initialProfile.needHelpWith.topics)
          setDesiredActivities(initialProfile.needHelpWith.desiredActivities)
          setPatentActivities(initialProfile.needHelpWith.patentActivities)
          setPatentsReadyOptions(initialProfile.needHelpWith.patentsReadyOptions)
          setAgreementSigned(initialProfile.needHelpWith.agreementSigned)
          if (initialProfile?.needHelpWith.specificDiscussion) {
            needHelpWithStateObj.specificDiscussion = initialProfile?.needHelpWith.specificDiscussion
          }
          if (initialProfile?.needHelpWith.desiredActivities.includes("Other") && initialProfile?.needHelpWith.activitiesOther) {
            needHelpWithStateObj.activitiesOther = initialProfile?.needHelpWith.activitiesOther
            setRequireDesiredActivitesOther(true)
          }
          if (initialProfile?.needHelpWith.patentActivities.includes("Other") && initialProfile?.needHelpWith.patentActivitiesOther) {
            needHelpWithStateObj.patentActivitiesOther = initialProfile?.needHelpWith.patentActivitiesOther
            setRequirePatentActivitiesOther(true)
          }
          if (initialProfile?.needHelpWith.searchCompleted) {
            needHelpWithStateObj.searchCompleted = initialProfile?.needHelpWith.searchCompleted
          }
          if (initialProfile?.needHelpWith.firmId) {
            needHelpWithStateObj.firmId = initialProfile?.needHelpWith.firmId
          }
          if (initialProfile?.needHelpWith.firmId === "Other" && initialProfile?.needHelpWith.firmOther) {
            needHelpWithStateObj.firmOther = initialProfile?.needHelpWith.firmOther
            setRequireFirmOther(true)
          }
          if (initialProfile?.needHelpWith.exclusiveRights) {
            needHelpWithStateObj.exclusiveRights = initialProfile?.needHelpWith.exclusiveRights
          }
          if (initialProfile?.needHelpWith.govtSupport !== null) {
            needHelpWithStateObj.govtSupport = initialProfile?.needHelpWith.govtSupport
            setGovtSupport(initialProfile.needHelpWith.govtSupport)
          }
          if (initialProfile?.needHelpWith.supportOrg) {
            needHelpWithStateObj.supportOrg = initialProfile?.needHelpWith.supportOrg
          }
          if (initialProfile?.needHelpWith.supportOrgOther) {
            needHelpWithStateObj.supportOrgOther = initialProfile?.needHelpWith.supportOrgOther
          }
          if (initialProfile?.needHelpWith.workingWithFirm || initialProfile?.needHelpWith.workingWithFirm === false) {
            needHelpWithStateObj.workingWithFirm = initialProfile?.needHelpWith.workingWithFirm
            setWorkingWithFirm(initialProfile.needHelpWith.workingWithFirm)
          }
          if (initialProfile?.needHelpWith.supportOrg === "Other") {
            setRequireSupportOrgOther(true)
          }
          const specificDiscussionBoolean = initialProfile.needHelpWith.businessGoal === false || initialProfile.needHelpWith.businessGoal === true && initialProfile.needHelpWith.specificDiscussion
          const topicsBoolean = initialProfile.needHelpWith.businessGoal === false || initialProfile.needHelpWith.businessGoal === true && initialProfile.needHelpWith.topics
          const desiredActivitiesOtherBoolean = !initialProfile.needHelpWith.desiredActivities.includes("other") || initialProfile.needHelpWith.desiredActivities.includes("other") && initialProfile.needHelpWith.activitiesOther 
          const patentActivitiesOtherBoolean = !initialProfile.needHelpWith.patentActivities.includes("other") || initialProfile.needHelpWith.desiredActivities.includes("other") && initialProfile.needHelpWith.patentActivitiesOther 
          const searchCompletedBoolean = !initialProfile.needHelpWith.patentActivities.includes("Trademark Filing") || initialProfile.needHelpWith.searchCompleted
          const workingWithFirmBoolean = initialProfile.needHelpWith.workingWithFirm === false || initialProfile.needHelpWith.workingWithFirm === true && initialProfile.needHelpWith.firmId
          const firmOtherBoolean = initialProfile.needHelpWith.workingWithFirm === false || initialProfile.needHelpWith.workingWithFirm === true && initialProfile.needHelpWith.firmId !== "Other" || initialProfile.needHelpWith.workingWithFirm === true && initialProfile.needHelpWith.firmId == "Other" && initialProfile.needHelpWith.firmOther
          const supportOrgBoolean = initialProfile.needHelpWith.govtSupport === false || initialProfile.needHelpWith.govtSupport === true && initialProfile.needHelpWith.supportOrg
          const supportOrgOtherBoolean = initialProfile.needHelpWith.govtSupport === false || initialProfile.needHelpWith.govtSupport === true && initialProfile.needHelpWith.supportOrg !== "Other" || initialProfile.needHelpWith.govtSupport === true && initialProfile.needHelpWith.supportOrg == "Other" && initialProfile.needHelpWith.supportOrgOther
          const exclusiveRightsBoolean = initialProfile.needHelpWith.patentActivities.length === 0 || initialProfile.needHelpWith.exclusiveRights
          const agreementSignedBoolean = initialProfile.needHelpWith.agreementSigned === false || initialProfile.needHelpWith.agreementSigned === true
          if (initialProfile.needHelpWith.seekingEducation !== null && initialProfile.needHelpWith.businessGoal !== null
            && specificDiscussionBoolean && topicsBoolean && desiredActivitiesOtherBoolean && patentActivitiesOtherBoolean && searchCompletedBoolean
            && initialProfile.needHelpWith.workingWithFirm !== null && workingWithFirmBoolean && firmOtherBoolean && initialProfile.needHelpWith.govtSupport !== null
            && supportOrgOtherBoolean && supportOrgBoolean && exclusiveRightsBoolean && agreementSignedBoolean
          ) {
            setNeedHelpWithComplete("complete")
          } else {
            console.log()

          }
        }
        if (initialProfile?.programingEvaluation) {
          setProgramingEvaluation(initialProfile?.programingEvaluation)
          setProgramingEvaluationComplete("complete")
        }

        // Register conditional render state
        const conditionalRenderInitialState = {
          isPointOfContact: !!initialProfile?.personalInfo?.isPointOfContact,
          isLegalNameSameAsOperatingName: !!initialProfile?.companyInfo?.basicInfo?.isLegalNameSameAsOperatingName,
          isWorkingWithLawFirm: !!initialProfile?.iPStrategy?.isWorkingWithLawFirm,
          isWorkingWithOrganization: !!initialProfile?.programingEvaluation?.isWorkingWithOrganization,
          isWorkingWithBai: !!initialProfile?.programingEvaluation?.isWorkingWithBai,
          isFromOLMC: !!initialProfile?.programingEvaluation?.isFromOLMC,
          filePatentReady: !!initialProfile?.iPStrategy?.filePatentReady,
          fileTrademarkReady: !!initialProfile?.iPStrategy?.fileTrademarkReady,
          isProductForSaleOnMarket: !!initialProfile?.programingEvaluation?.isProductForSaleOnMarket,
        }
        conditionalRenderContext.replaceConditionalRenderState(conditionalRenderInitialState);
      }
      fetchFounderProfile().catch(console.error);
    } catch (err) {
      console.error(err);
    }
    // eslint-disable-next-line 
  }, [updateTier, pdfSaved, programingEvaluationComplete, ]);

  useEffect(() => {
    htmlCheck()
  }, [founderProfile]);

  // logic to handle FormGroup validation on FounderProfile
  const handleSubmissionReject = (message?: string) => {
    showToast({
      toastType: "info",
      title: textData.Pages.FounderPages.FounderProfile.UnsuccessfulSubmit[langState],
      message: message || textData.Pages.FounderPages.FounderProfile.UnsuccessfulSubmitMessage[langState],
    })
  }

  const handleSubmitMembershipApplication = async () => {

    if (!founderProfile) {
      handleSubmissionReject();
      return;
    }
    
    const { 
      personalInfo, 
      pointOfContact, 
      companyInfo, 
      programingEvaluation, 
      needHelpWith,
    } = founderProfile;

    if (!companyInfo) {
      handleSubmissionReject();
      return;
    }

    const { registration, 
            mailingAddress, 
            basicInfo } = companyInfo;

    if (
      personalInfo === null ||
      (!personalInfo.isPointOfContact && pointOfContact === null) || // is not point of contact but PoC data is missing
      basicInfo === null ||
      (registration === null) || 
      mailingAddress === null ||
      needHelpWith === null ||
      programingEvaluation === null 
    ) {
      handleSubmissionReject();
      return;
    }

    if (memberApplicationStatus === "pendingEditRequest") {
      showLoading();
      const response = await editedApplicationChange();
      hideLoading();
      if (response.success && !response.autoReject) {
        setMemberApplicationStatus(response.applicationStatus);
        navigate("/dashboard");
      } 
      handleFormSaveResponse (
        response, 
        showToast, 
        {message: textData.Pages.FounderPages.FounderProfile.SuccessfulSubmit[langState]}, 
        {title: textData.Pages.FounderPages.FounderProfile.AttemptUnsuccessfulTitle[langState], message: (response.message ? response.message : textData.Pages.FounderPages.FounderProfile.ServerErrorSubmitMessage[langState]), autoDisappearTimeInSeconds: 8}
      );
    } else {
      showLoading();
      const programId = (await getRegionalMembershipId()).membershipId;
      const response = await createFounderApplication(programId);
      hideLoading();
      if (response.success && !response.autoReject) {
        setMemberApplicationStatus(response.applicationStatus);
        navigate("/dashboard");
      } 
      handleFormSaveResponse (
        response, 
        showToast, 
        {message: textData.Pages.FounderPages.FounderProfile.SuccessfulSubmit[langState]}, 
        {title: textData.Pages.FounderPages.FounderProfile.AttemptUnsuccessfulTitle[langState], message: (response.message ? response.message : textData.Pages.FounderPages.FounderProfile.ServerErrorSubmitMessage[langState]), autoDisappearTimeInSeconds: 8}
      );
    }
  }
  
  async function handleSaveSection(updatedSectionFormData: FormData, sectionKey: string) {
    const emptyProfile = {
      personalInfo: null, 
      pointOfContact: null, 
      companyInfo: null,
      iPStrategy: null, 
      ipReadiness: null,
      pitchDeck: null,
      programingEvaluation: null,
      needHelpWith: null,
      sLASigningTimestamp: new Date(),
    }

    const updatedFounderProfile: T.StartupFounderProfile = founderProfile === null ? emptyProfile : {...founderProfile};
    switch (sectionKey as FounderProfileSectionKey) {
      case "personalInfo":
        const personal = updatedSectionFormData as T.PersonalInfo
        updatedFounderProfile.personalInfo = {
            firstName: personal.firstName,
            lastName: personal.lastName,
            pronouns: personal.pronouns,
            title: personal.title,
            phoneNumber: personal.phoneNumber,
            isPointOfContact: true
        }
        if (updatedFounderProfile.personalInfo.isPointOfContact) {
          updatedFounderProfile.pointOfContact = null;
        }
        break;
      case "companyInfo":
        console.log(companyInfoStateObj)
        const address = mailingAddress as unknown
        console.log(revFromTech)
        if (
          companyInfoStateObj.legalName && 
          companyInfoStateObj.description &&
          companyInfoStateObj.industry &&
          companyInfoStateObj.websiteURL &&
          companyInfoStateObj.linkedInURL &&
          companyInfoStateObj.numFullTimeEmployees !== null &&
          companyInfoStateObj.numFullTimeEmployeesCan !== null &&
          companyInfoStateObj.revenueOverTwelveMonths !== null &&
          revFromTech !== null &&
          companyInfoStateObj.techReadiness &&
          companyInfoStateObj.numFullTimeEmployeesCan !== null  &&       
          regDate !== null &&
          companyInfoStateObj.number
        ) {
          console.log("herhehrehr")

          updatedFounderProfile.companyInfo = {

            basicInfo: {
                operatingName: companyName,
                legalName: companyInfoStateObj.legalName as string,
                description: companyInfoStateObj.description as string,
                industry: companyInfoStateObj.industry as string,
                websiteURL: companyInfoStateObj.websiteURL as string,
                linkedInURL: companyInfoStateObj.linkedInURL as string,
                revenueOverTwelveMonths: companyInfoStateObj.revenueOverTwelveMonths as number,
                tech: tech as string[],
                numFullTimeEmployees: companyInfoStateObj.numFullTimeEmployees as number,
                numFullTimeEmployeesCan: companyInfoStateObj.numFullTimeEmployeesCan as number,
                revFromTech: revFromTech as boolean,
                techReadiness: companyInfoStateObj.techReadiness as string,
                patentsGranted: companyInfoStateObj.patentsGranted as number
            },
            registration: {
                number: companyInfoStateObj.number,
                date: regDate as Date,
                province: province as T.ProvinceCode[],
                registeredFederally: federalRegistered as boolean,
                registeredProvincially: provincialRegistered as boolean
            },
            mailingAddress: address as Address
          }
          if (requireIndusrtyOther && updatedFounderProfile.companyInfo.basicInfo) {
            updatedFounderProfile.companyInfo.basicInfo.industryOther = companyInfoStateObj.industryOther as string
          }
          if (requireTechOther && updatedFounderProfile.companyInfo.basicInfo) {
            updatedFounderProfile.companyInfo.basicInfo.techOther = companyInfoStateObj.techOther as string
          }
          
        } else {
          console.log(revFromTech, "sdjfsjksdfhjksfd")
        }
        break;
      case "needHelpWith": 
        updatedFounderProfile.needHelpWith = {
          seekingEducation: seekingEducation as boolean,
          businessGoal: businessGoal as boolean,
          topics: topics,
          agreementSigned: agreementSigned as boolean,
          desiredActivities: desiredActivities,
          patentActivities: patentActivities,
          patentsReadyOptions: patentsReadyOptions,
          workingWithFirm: workingWithFirm as boolean,
          govtSupport: govtSupport as boolean,
        }
        if (needHelpWithStateObj.firmId) {
          updatedFounderProfile.needHelpWith.firmId = needHelpWithStateObj.firmId as string
        }
        if (needHelpWithStateObj.specificDiscussion) {
          updatedFounderProfile.needHelpWith.specificDiscussion = needHelpWithStateObj.specificDiscussion as string
        }
        if (requireDesiredActivitesOther && needHelpWithStateObj.activitiesOther) {
          updatedFounderProfile.needHelpWith.activitiesOther = needHelpWithStateObj.activitiesOther as string
        }
        if (requirePatentActivitiesOther && needHelpWithStateObj.patentActivitiesOther) {
          updatedFounderProfile.needHelpWith.patentActivitiesOther = needHelpWithStateObj.patentActivitiesOther as string
        }
        if (needHelpWithStateObj.searchCompleted) {
          updatedFounderProfile.needHelpWith.searchCompleted = needHelpWithStateObj.searchCompleted as string
        }
        if (needHelpWithStateObj.exclusiveRights) {
          updatedFounderProfile.needHelpWith.exclusiveRights = needHelpWithStateObj.exclusiveRights as string
        }
        if (requireFirmOther && needHelpWithStateObj.firmOther) {
          updatedFounderProfile.needHelpWith.firmOther = needHelpWithStateObj.firmOther as string
        }
        if (govtSupport && needHelpWithStateObj.supportOrg) {
          updatedFounderProfile.needHelpWith.supportOrg = needHelpWithStateObj.supportOrg as string
        }
        if (requireSupportOrgOther && needHelpWithStateObj.supportOrgOther) {
          updatedFounderProfile.needHelpWith.supportOrgOther = needHelpWithStateObj.supportOrgOther as string
        }
        break;
      case "programingEvaluation":
        const underRepresentedGroupsArray = updatedSectionFormData.underrepresentedFounderGroups as string[];
        const isOwnedByUnderrepresentedGroups = !underRepresentedGroupsArray.includes("none");
        updatedSectionFormData.isOwnedByUnderrepresentedGroups = isOwnedByUnderrepresentedGroups
        updatedFounderProfile.programingEvaluation = updatedSectionFormData as T.ProgramingEvaluation;
        break;
      default:
        throw new Error(`Unknown sectionKey: ${sectionKey}`);
    }
    //MIGHT HAVE TO GO IN THE SUCCESS, SET THE STATE TO THE RETURN FROM STARTUPFOUNDER PROFILE
    showLoading();
    const res = await updateUserProfile("startupFounder", updatedFounderProfile);
    hideLoading();
    if (res.success) {
    setFounderProfile(updatedFounderProfile);
    // // reLOAD AFter SECtION SAVE, MAYBE CAN GO
    switch (sectionKey as FounderProfileSectionKey) {
      case "personalInfo":
        setPersonalInfoComplete("complete")
        setCurrentHTML("companyInfo")
        break;
      case "companyInfo":
        setCompanyInfoComplete("complete")
        setCurrentHTML("needHelpWith")
        break;
      case "needHelpWith":
        setNeedHelpWithComplete("complete")
        setCurrentHTML("programingEvaluation")
        break;
      case "programingEvaluation":
        setProgramingEvaluationComplete("complete")
        if (personalInfoComplete === "complete" 
          && companyInfoComplete === "complete"
          && pitchDeckComplete === "complete"          
          && programingEvaluationComplete === "complete") {
            setCurrentHTML("review")
          } else (
            htmlCheck()
          )
        break;
      default:
        throw new Error(`Unknown sectionKey: ${sectionKey}`);
    }
    } else {
      showToast({
        toastType: "failure",
        message: textData.Pages.FounderPages.FounderProfile.SectionToastFail[langState]
      })
    }
  }

  const companyInfoErrorCheck = () => {
    let i = 0
    if (!companyInfoStateObj.legalName) {
      setErrorArray(prev => [...prev, "legalName"])
      i++
    console.log(i)
    }
    if (!companyInfoStateObj.description) {
      setErrorArray(prev => [...prev, "description"])  
      i++
    console.log(i)
      
    }
    if (!companyInfoStateObj.industry) {
      setErrorArray(prev => [...prev, "industry"])  
      i++
    console.log(i)
      
    }
    if (!companyInfoStateObj.websiteURL) {
      setErrorArray(prev => [...prev, "websiteURL"])  
      i++
    console.log(i)
      
    }
    if (!companyInfoStateObj.linkedInURL) {
      setErrorArray(prev => [...prev, "linkedInURL"])  
      i++
    console.log(i)
      
    }        
    if (tech.length === 0) {
      setErrorArray(prev => [...prev, "tech"])  
      i++
      console.log(i)
  }    
    if (requireTechOther) {
      if (!companyInfoStateObj.techOther) {
        setErrorArray(prev => [...prev, "techOther"])
        i++
      }
    }
    if (companyInfoStateObj.numFullTimeEmployees !== 0 && !companyInfoStateObj.numFullTimeEmployees) {
      setErrorArray(prev => [...prev, "numFullTimeEmployees"])  
      i++
    console.log(i)
      
    }    
    if (companyInfoStateObj.numFullTimeEmployeesCan !== 0 && !companyInfoStateObj.numFullTimeEmployeesCan) {
      setErrorArray(prev => [...prev, "numFullTimeEmployeesCan"])  
      i++
    console.log(i)
      
    }
    if (revFromTech === null) {
      setErrorArray(prev => [...prev, "revFromTech"])  
      i++
      
      console.log(i)
  }
    if (requireIndusrtyOther) {
      if (!companyInfoStateObj.industryOther) {
        setErrorArray(prev => [...prev, "industryOther"])
        i++
        
    console.log(i)
      }
    }
    if (!companyInfoStateObj.techReadiness) {
      setErrorArray(prev => [...prev, "techReadiness"])  
      i++
    console.log(i)
      
    }
    if (companyInfoStateObj.patentsGranted !== 0 && !companyInfoStateObj.patentsGranted) {
      setErrorArray(prev => [...prev, "patentsGranted"])
      i++
    console.log(i)
        
    }
    if (regDate === null) {
      setErrorArray(prev => [...prev, "date"])
      i++
    console.log(i)
        
    }
    if (federalRegistered === null) {
      setErrorArray(prev => [...prev, "registeredFederally"])
      i++
      console.log(i) 
    }
    if (provincialRegistered === null) {
      setErrorArray(prev => [...prev, "registeredProvincially"])
      i++
      console.log(i) 
    }
    if (companyInfoStateObj.revenueOverTwelveMonths !== 0 && !companyInfoStateObj.revenueOverTwelveMonths) {
      setErrorArray(prev => [...prev, "revenueOverTwelveMonths"])
      i++
      console.log(i)

    }
    if (!companyInfoStateObj.number) {
      setErrorArray(prev => [...prev, "number"])
      i++
      console.log(i)
    }
    if (provincialRegistered && province.length === 0) {
      setErrorArray(prev => [...prev, "province"])
      i++
      console.log(i)
    }
    if (i === 0) {
      handleSaveSection({}, "companyInfo")
    } else {
      setSubmittedSectionError(!submittedSectionError)
      showToast({
        toastType: "failure",
        message: textData.Pages.FounderPages.FounderProfile.RequiedFields[langState]
      })
    }
  }

  useEffect(() => {
    const firstError = document.querySelector('.reqFieldError');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }}, [submittedSectionError])


  const needHelpWithErrorCheck = () => {
    let i = 0
    if (seekingEducation === null) {
      setErrorArray(prev => [...prev, "seekingEducation"])
      i++
      console.log(i) 
    }
    if (agreementSigned === null) {
      setErrorArray(prev => [...prev, "agreementSigned"])
      i++
      console.log(i) 
    }
    if (workingWithFirm === null) {
      setErrorArray(prev => [...prev, "workingWithFirm"])
      i++
      console.log(i) 
    }
    if (businessGoal === null) {
      setErrorArray(prev => [...prev, "businessGoal"])
      i++
      console.log(i) 
    }
    if (businessGoal && !needHelpWithStateObj.specificDiscussion) {
      setErrorArray(prev => [...prev, "specificDiscussion"])
      i++
      console.log(i) 
    }
    if (businessGoal && topics.length === 0) {
      setErrorArray(prev => [...prev, "topics"])
      i++
      console.log(i) 
    }
    if (requireDesiredActivitesOther && !needHelpWithStateObj.activitiesOther) {
      setErrorArray(prev => [...prev, "activitiesOther"])
      i++
      console.log(i) 
    }
    
    if (requirePatentActivitiesOther && !needHelpWithStateObj.patentActivitiesOther) {
      setErrorArray(prev => [...prev, "patentActivitiesOther"])
      i++
      console.log(i) 
    }
    if (patentActivities.length > 0 && !needHelpWithStateObj.exclusiveRights) {
      if (!founderProfile?.needHelpWith?.exclusiveRights) {
        setErrorArray(prev => [...prev, "exclusiveRights"])
        i++
        console.log(i) 
      }
      setErrorArray(prev => [...prev, "exclusiveRights"])
      i++
      console.log(i) 
    }

    if (patentActivities.includes("Trademark Filing")  && !needHelpWithStateObj.searchCompleted) {
      setErrorArray(prev => [...prev, "searchCompleted"])
      i++
      console.log(i) 
    }
    if (patentActivities.includes("Patent Filing") && patentsReadyOptions.length === 0) {
      setErrorArray(prev => [...prev, "patentsReadyOptions"])
      i++
      console.log(i) 
    }
    if (workingWithFirm === null) {
      setErrorArray(prev => [...prev, "workingWithFirm"])
      i++
    console.log(i)
    }
    if (workingWithFirm && !needHelpWithStateObj.firmId) {
      setErrorArray(prev => [...prev, "firmId"])
      i++
      console.log(i) 
    }
    if (requireFirmOther && !needHelpWithStateObj.firmOther) {
      setErrorArray(prev => [...prev, "firmOther"])
      i++
      console.log(i) 
    }
    if (govtSupport === null) {
      setErrorArray(prev => [...prev, "govtSupport"])
      i++
      console.log(i) 
    }
    if (govtSupport && !needHelpWithStateObj.supportOrg) {
      setErrorArray(prev => [...prev, "supportOrg"])
      i++
      console.log(i) 
    }
    if (requireSupportOrgOther && !needHelpWithStateObj.supportOrgOther) {
      setErrorArray(prev => [...prev, "supportOrgOther"])
      i++
      console.log(i) 
    }

    if (i === 0) {
      handleSaveSection({}, "needHelpWith")
    } else {
      showToast({
        toastType: "failure",
        message: textData.Pages.FounderPages.FounderProfile.RequiedFields[langState]
      })
      setSubmittedSectionError(!submittedSectionError)
    }
  }

  const attestaionPrompt = () => {
    
    showToast({
      toastType: "failure",
      message: textData.Pages.FounderPages.FounderProfile.AttestationFailure[langState]
    })
  }

  const attestationTextEng = `I, ${founderProfile?.personalInfo?.firstName} ${founderProfile?.personalInfo?.lastName}, have legal authority to represent ${founderProfile?.companyInfo?.basicInfo?.operatingName} and attest that the support provided by Communitech / Invest Ottawa / North Forge under the ElevateIP program will not be used for any services that are already funded by another government program or grant. Any use of the ElevateIP program funds on services that are already funded by another government program or grant may lead to immediate termination from the ElevateIP program and/or the immediate return of such funding.`
  const attestationTextFr = `Je, ${founderProfile?.personalInfo?.firstName} ${founderProfile?.personalInfo?.lastName}, ai l'autorité légale de représenter ${founderProfile?.companyInfo?.basicInfo?.operatingName} et j'atteste que le soutien fourni par Communitech / Invest Ottawa / North Forge dans le cadre du programme ElevateIP ne sera pas utilisé pour des services qui sont déjà financés par un autre programme gouvernemental ou une subvention.  Toute utilisation des fonds du programme ÉleverlaPI pour des services qui sont déjà financés par un autre programme gouvernemental ou une subvention pourrait entraîner l'annulation immédiate du programme ÉleverlaPI et/ou la demande de restitution immédiate de ces fonds.`


  const communitechAttestation = langState === "fr" ? attestationTextFr : attestationTextEng

  const modalHTML  = (
    <div className="flex flex-col gap-6 p-5">
        <h2 className="text-center">Attestation</h2>
        <p className="">{communitechAttestation}</p>
        <div className='flex w-full items-center'>
          <input 
            type="checkbox" 
            checked={isAttestaionChecked}
            onChange={() => setIsAttestaionChecked(!isAttestaionChecked)}
          />
          <p className="ml-5">{textData.Pages.FounderPages.FounderProfile.Confirm[langState]}</p>
      </div>
    </div>
  )

  const pdfSave = () => {
    setPitchDeckComplete("complete")
    htmlCheck()
    setCurrentHTML("needHelpWith")
    setPdfSaved(true)
  }

  const saveSectionInfo = (updateForm: FormData) => {
    handleSaveSection(updateForm, currentHTML)
  }

  const saveSectionButtonProp: ButtonProp = {
    buttonText: "Save",
    actionHandler: saveSectionInfo
  }

  const companyInfoToForm = (info: T.CompanyInfo) => {
    return flattenObject({basicInfo: info.basicInfo, registration: info.registration})
  }

  const bnNumLink = document.querySelector('a[href="https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html"]');
    if (bnNumLink) {
      bnNumLink.classList.add('underline');
    }

    const handleCompanyInfoChangeString = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
      const { id, value } = event.target;
      console.log(id, value, errorArray)
      if (errorArray.includes(id)) {
        console.log("yaaaa")
        setErrorArray(prev => prev.filter(item => item !== id));
      }
      let modifyValue: string | number | boolean = value
      if (id === "number" && modifyValue !== "" || id === "numFullTimeEmployees" && modifyValue !== "" || id === "numFullTimeEmployeesCan" && modifyValue !== ""  || id === "revenueOverTwelveMonths" && modifyValue !== "" || id === "patentsGranted" && modifyValue !== "" ) {
        modifyValue = parseInt(value)
      }
      setCompanyInfoStateObj(prev => ({
        ...prev,
        [id]: modifyValue,
      }));
    };

    const handleCompanyInfoChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const { id, value } = event.target;
      if (errorArray.includes(id)) {
        setErrorArray(prev => prev.filter(item => item !== id));
      }
      if (id === "industry" && value === "Other") {
        setRequireIndusrtyOther(true)
      } else if (id === "industry" && value !== "Other") {
        if (errorArray.includes("industryOther")) {
          setErrorArray(prev => prev.filter(item => item !== "industryOther"));
        }
        setRequireIndusrtyOther(false)
      }
      setCompanyInfoStateObj(prev => ({
        ...prev,
        [id]: value,
      }));
    };

    const requiredFieldErrorMessage = <p className="flex items-center gap-1 ml-2 px-2 font-semibold text-cError reqFieldError" style={{opacity: "1", transform: "none"}}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" className="svg-inline--fa fa-circle-exclamation " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"></path></svg>Required Field</p>
  
    const handleRegDateChange = (date: Date | null | undefined) => {
      console.log("woasdasdasoo")
      console.log(typeof date)

      if (date) {
        console.log("wooo")
        setRegDate(date);
        setErrorArray(prev => prev.filter(item => item !== "date"));

      }
    };
  
    const handleTechCheckboxChange = (value: string) => {

      setTech(prev => {
        const updated = prev.includes(value)
          ? prev.filter(v => v !== value)
          : [...prev, value];
  
        // Check for "Other" after update
        setRequireTechOther(updated.includes("Other"));
        return updated;
      });
    };
  
    const handleProvinceCheckboxChange = (value: string) => {
      setProvince(prev => {
        const updated = prev.includes(value)
          ? prev.filter(v => v !== value)
          : [...prev, value];
        return updated;
      });
    };

    const handleNeedHelpWithChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>) => {
      const { id, value } = event.target;
      if (id === "firmId" && value === "Other") {
        setRequireFirmOther(true)
        
      }
      if (id === "firmId" && value !== "Other") {
        setRequireFirmOther(false)
        if (errorArray.includes("firmOther")) {
          setErrorArray(prev => prev.filter(item => item !== "firmOther"));
        }
      }
      if (id === "supportOrg" && value === "Other") {
        setRequireSupportOrgOther(true)
      }
      if (id === "supportOrg" && value !== "Other") {
        setRequireSupportOrgOther(false)
        if (errorArray.includes("supportOrgOther")) {
          setErrorArray(prev => prev.filter(item => item !== "supportOrgOther"));
        }
      }
      if (errorArray.includes(id)) {
        setErrorArray(prev => prev.filter(item => item !== id));
      }
      setNeedHelpWithStateObj(prev => ({
        ...prev,
        [id]: value,
      }));
    };

    const handleTopicsCheckboxChange = (value: string) => {
      if (errorArray.includes("topics")) {
        setErrorArray(prev => prev.filter(item => item !== "topics"));
      }
      setTopics(prev => {
        const updated = prev.includes(value)
          ? prev.filter(v => v !== value)
          : [...prev, value];
  
        return updated;
      });
    };

    useEffect(() => {
      if (errorArray.includes("patentsReadyOptions")) {
        if (patentsReadyOptions.length > 0) {
          setErrorArray(prev => prev.filter(item => item !== "patentsReadyOptions"));
        }
      }
    }, [patentsReadyOptions])

    useEffect(() => {
      if (errorArray.includes("tech")) {
        if (tech.length > 0) {
          setErrorArray(prev => prev.filter(item => item !== "tech"));
        }
      }
    }, [tech])

    const handlePatentsReadyOptionsCheckboxChange = (value: string) => {
      setPatentsReadyOptions(prev => {
        const updated = prev.includes(value)
          ? prev.filter(v => v !== value)
          : [...prev, value];
        return updated;
      });
    }

    const handleDesiredActivitesCheckboxChange = (value: string) => {
      if (errorArray.includes("desiredActivities")) {
        setErrorArray(prev => prev.filter(item => item !== "desiredActivities"));
      }
      setDesiredActivities(prev => {
        const updated = prev.includes(value)
          ? prev.filter(v => v !== value)
          : [...prev, value];
  
        // Check for "Other" after update
        setRequireDesiredActivitesOther(updated.includes("Other"));
        return updated;
      });
    };

    const handlePatentActivitesCheckboxChange = (value: string) => {
      if (errorArray.includes("patentActivities")) {
        setErrorArray(prev => prev.filter(item => item !== "patentActivities"));
      }
      setPatentActivities(prev => {
        const updated = prev.includes(value)
          ? prev.filter(v => v !== value)
          : [...prev, value];
  
        // Check for "Other" after update
        if (errorArray.includes("searchCompleted") && !updated.includes("Trademark Filing")) {
          setErrorArray(prev => prev.filter(item => item !== "searchCompleted"));
        }
        if (errorArray.includes("exclusiveRights") && updated.length === 0) {
          setErrorArray(prev => prev.filter(item => item !== "exclusiveRights"));
        }
        setRequirePatentActivitiesOther(updated.includes("Other"));
        return updated;
      });
    };

  return (
    <div className="flex" id="top">
        {
      <div className="applicationSideMenu">
        <div className="flex flex-col gap-8 applicationSideMenuInner" id="applicationSideMenuInner">
          <div className="flex flex-col">
            <h1 className="mb-8">{textData.Pages.FounderPages.FounderProfile.YourApp[langState]}</h1>
            <div className="flex-col">
              <div className={`applicationSideItem`}>
                <button 
                  onClick={() => setCurrentHTML("personalInfo")} 
                  disabled={memberApplicationStatus === "pending"} 
                  className={memberApplicationStatus === "pending" ? "hover:cursor-not-allowed" : currentHTML === "personalInfo" ? `font-semibold` : "hover:underline"}
                >
                  {textData.Pages.FounderPages.FounderProfile.YourInfo[langState]}
                </button>
                {currentHTML === "personalInfo" ? currentCircle : personalInfoComplete === "complete" ? completeCircle : incompleteCircle}
              </div>
              <div className="applicationSpacer">
                <div></div>
              </div>
            </div>
            <div className="flex-col">
              <div className={`applicationSideItem `}>
                <button 
                  onClick={() => setCurrentHTML("companyInfo")} 
                  disabled={memberApplicationStatus === "pending"} 
                  className={memberApplicationStatus === "pending" ? "hover:cursor-not-allowed" : currentHTML === "companyInfo" ? `font-semibold` : "hover:underline"}
                >
                  {textData.Pages.FounderPages.FounderProfile.CompanyInfo[langState]}
                </button>
                {currentHTML === "companyInfo" ? currentCircle : companyInfoComplete === "complete" ? completeCircle : incompleteCircle}
              </div>
              <div className="applicationSpacer">
                <div></div>
              </div>
            </div>
            <div className="flex-col">
              <div className={`applicationSideItem `}>
                <button 
                  onClick={() => setCurrentHTML("pitchDeck")} 
                  // disabled={memberApplicationStatus === "pending" || companyInfoComplete === "incomplete"} 
                  className={memberApplicationStatus === "pending" ? "hover:cursor-not-allowed" : currentHTML === "pitchDeck" ? `font-semibold` : "hover:underline"}
                >
                  Pitch Deck
                </button>
                {currentHTML === "pitchDeck" ? currentCircle : pitchDeckComplete === "complete" ? completeCircle : incompleteCircle} 
              </div>
              <div className="applicationSpacer">
                <div></div>
              </div>
            </div>
            <div className="flex-col">  
              <div className={`applicationSideItem `}>
                <button 
                  onClick={() => setCurrentHTML("needHelpWith")} 
                  disabled={memberApplicationStatus === "pending"} 
                  className={memberApplicationStatus === "pending" ? "hover:cursor-not-allowed" : currentHTML === "needHelpWith" ? `font-semibold` : "hover:underline"}
                >
                  Need Help With
                </button>
                {currentHTML === "iPStrategy" ? currentCircle : needHelpWithComplete === "complete" ? completeCircle : incompleteCircle}
              </div>
              <div className="applicationSpacer">
                <div></div>
              </div>
            </div>
            <div className={`applicationSideItem `}>
              <button 
                onClick={() => setCurrentHTML("programingEvaluation")} 
                disabled={memberApplicationStatus === "pending"} 
                className={memberApplicationStatus === "pending" ? "hover:cursor-not-allowed text-left" : currentHTML === "programingEvaluation" ? `font-semibold text-left` : "hover:underline text-left"}
              >
                Community, Culture & Climate
              </button>
              {programingEvaluationComplete === "complete" ? completeCircle : incompleteCircle}
            </div>
          </div>
        </div>
        {currentHTML === "review"
        ?
        <div></div>
        :
        <div className={memberApplicationStatus === "pending" 
          || memberApplicationStatus === "pendingEditRequest"
          || memberApplicationStatus === "approved" 
          || personalInfoComplete === "incomplete"
          || companyInfoComplete === "incomplete"
          || pitchDeckComplete === "incomplete"          
          || programingEvaluationComplete === "incomplete"
           ? "hidden" : "" }>
          <Button
            buttonText={textData.Pages.FounderPages.FounderProfile.Submit[langState]}
            disabled={memberApplicationStatus === "pending" ? true : memberApplicationStatus === "rejected" ? true : programingEvaluationComplete === "complete" ? false : true}
            actionHandler={() => setCurrentHTML("review")}
          />
        </div>
        }
      </div>
    }
      <div className='flex flex-col justify-center align-middle items-center overflow-y-auto h-full w-full menuOffset'>
        <header className="dashboardHeader ">
          <div className='headerSect'>
              <button className='flex bodyLarger buttonSizer' onClick={() => handleLangToggle()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" className='mr-2 relative bottom-0.5'><circle cx="8" cy="8.5" r="7.5" stroke="#000000"/><path d="M10.5 8.5C10.5 10.6651 10.1701 12.6029 9.65316 13.9813C9.39401 14.6723 9.0975 15.1969 8.79361 15.5396C8.4892 15.883 8.21987 16 8 16C7.78013 16 7.5108 15.883 7.20639 15.5396C6.9025 15.1969 6.60599 14.6723 6.34684 13.9813C5.82994 12.6029 5.5 10.6651 5.5 8.5C5.5 6.33494 5.82994 4.39713 6.34684 3.01871C6.60599 2.32765 6.9025 1.80314 7.20639 1.46038C7.5108 1.11704 7.78013 1 8 1C8.21987 1 8.4892 1.11704 8.79361 1.46038C9.0975 1.80314 9.39401 2.32765 9.65316 3.01871C10.1701 4.39713 10.5 6.33494 10.5 8.5Z" stroke="#000000"/><path d="M0.5 8.5H15.5" stroke="#000000" strokeLinecap="round"/></svg>
                  <span className='relative'>{langState === "eng" ? "ENG" : "FR"}</span>
              </button>
            <button 
              className='flex bodyLarger buttonSizer'
              onClick={logout}
            >
              <svg className='mr-2' xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none"><path d="M2.60117 12.6826L2.62197 12.7105L2.62194 12.7105C3.31089 13.6256 4.21794 14.3783 5.26877 14.8979C6.29021 15.403 7.45043 15.6879 8.68188 15.6879C10.7469 15.6879 12.616 14.8831 13.9688 13.5821C15.3215 12.2811 16.1575 10.4843 16.1575 8.50003C16.1575 6.51571 15.3214 4.71894 13.9688 3.41797C12.616 2.11692 10.7469 1.31213 8.68188 1.31213C7.45417 1.31213 6.29756 1.59507 5.27926 2.09609C4.22058 2.61748 3.30739 3.37501 2.61589 4.29603C2.47204 4.48838 2.19528 4.53117 1.99654 4.39366C1.7966 4.25534 1.75032 3.98628 1.89506 3.79278L1.89513 3.7927C2.66968 2.76184 3.69136 1.91429 4.87674 1.33069C6.02011 0.767551 7.31393 0.45 8.68198 0.45C10.9922 0.45 13.0844 1.3506 14.5986 2.80692L14.5986 2.80692C16.1128 4.26383 17.05 6.27677 17.05 8.5C17.05 10.7236 16.1128 12.7367 14.5986 14.1931L14.5986 14.1931C13.0838 15.6494 10.9917 16.55 8.68198 16.55C7.30756 16.55 6.00899 16.2298 4.86243 15.6631C3.6733 15.0754 2.65003 14.2223 1.8771 13.1858L1.87704 13.1857C1.73295 12.9917 1.77975 12.7217 1.98023 12.5834C2.17965 12.4458 2.45741 12.4898 2.60117 12.6826ZM1.08524 8.18019L1.11158 8.15552L3.75033 5.61765C3.9241 5.44997 4.20534 5.45004 4.37955 5.61756C4.55497 5.78575 4.55487 6.05954 4.37958 6.22813L4.34492 6.19209L4.37957 6.22813L2.47601 8.05837H11.5025C11.7472 8.05837 11.9485 8.24931 11.9485 8.48921C11.9485 8.72918 11.7471 8.92005 11.5025 8.92005H2.47599L4.37952 10.7508C4.55495 10.919 4.55488 11.1927 4.37964 11.3613C4.20586 11.529 3.9246 11.5289 3.75039 11.3614L1.08524 8.79814C1.08516 8.79807 1.08508 8.79799 1.085 8.79791C1.06218 8.7765 1.04208 8.75257 1.02468 8.72795L1.0243 8.72822L1.02255 8.72485L1.01816 8.71829L1.0134 8.71117L1.01314 8.71134L1.01082 8.70687C0.972479 8.64331 0.950001 8.56882 0.950001 8.48917C0.950001 8.40969 0.972374 8.33537 1.01055 8.2719L1.01031 8.27177L1.0134 8.26716L1.01816 8.26005L1.01717 8.25938L1.02099 8.25572L1.02438 8.2508C1.04224 8.22498 1.06258 8.20142 1.08524 8.18019Z" fill="#1A2E25" stroke="#1A2E25" strokeWidth="0.1"/></svg>
              <span className="relative">{textData.Components.SideMenu.Logout[langState]}</span>
            </button>
          </div>
          </header>
          <div className="w-full flex flex-col px-24 mb-16">
          {
            currentHTML === "personalInfo" &&
            <div className="flex-col flex">
              <h3 className="mb-8">{textData.Pages.FounderPages.FounderProfile.YourInfo[langState]}</h3>
                <Form
                  formDefinition={profileFormPersonalInfoDefinition}
                  formData={personalInfo}
                  primaryButtonProp={saveSectionButtonProp}
                  modifierFunc={personalFormModifier}
                />
            </div>
          }
          {
            currentHTML === "companyInfo" &&
            <div className="flex flex-col">
              <h3 className="mb-8">{textData.Pages.FounderPages.FounderProfile.CompanyInfo[langState]}</h3>
              <div className="flex flex-wrap w-full items-center">
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="companyName">Operating Name</label>
                      {errorArray.includes("companyName") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input disabled={true} onChange={handleCompanyInfoChangeString} type="text" placeholder="Company Name" id="companyName" className="w-full bodyLarger input !border-cSecondaryGreen border" name="companyName" value={companyName}></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="legalName">Legal Name</label>
                      {errorArray.includes("legalName") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input type="text" placeholder="Legal Name" id="legalName" name="legalName" 
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    value={companyInfoStateObj.legalName} onChange={handleCompanyInfoChangeString}></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="description">Description</label>
                      {errorArray.includes("description") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <textarea placeholder="Description" id="description" name="description" 
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    value={companyInfoStateObj.description} onChange={handleCompanyInfoChangeString}></textarea>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="industry">Industry</label>
                      {errorArray.includes("industry") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <select placeholder="Industry" id="industry" name="industry" 
                    className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                    value={companyInfoStateObj.industry || ""} onChange={handleCompanyInfoChangeSelect}>
                      <option disabled value={""}>Please make a selection</option>
                      <option value={"Agriculture"}>
                        {langState === "fr" ? "Agriculture" : "Agriculture"}
                      </option>
                      <option value={"Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences"}>
                        {langState === "fr" ? "Matériaux d’avant-garde et fabrication Exclut spécifiquement la sylviculture, l'agriculture, l'exploitation minière, les technologies propres et les sciences de la vie." : "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences"}
                      </option>
                      <option value={"Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources"}>
                        {langState === "fr" ? "Tech. propres : technologies qui protègent et/ou augmentent l’utilisation efficace des ressources de la terre, de l'eau et de l’air" : "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources"}
                      </option>
                      <option value={"Consumer Retail"}>
                        {langState === "fr" ? "Consommation de détail" : "Consumer Retail"}
                      </option>
                      <option value={"Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions"}>
                        {langState === "fr" ? "Médias numériques et télécommunications Applications numériques et technologies de l’information et de communication Exclut les soins de santé, l'agriculture, la sylviculture, l'exploitation minière, les services financiers, l'éducation, l'innovation sociale, la culture et loisirs, et les solutions liées à l'énergie." : "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions"}
                      </option>
                      <option value={"Education"}>
                        {langState === "fr" ? "Éducation" : "Education"}
                      </option>
                      <option value={"Financial Services"}>
                        {langState === "fr" ? "Services financiers" : "Financial Services"}
                      </option>
                      <option value={"Food & Beverage"}>
                        {langState === "fr" ? "Restauration/production d’aliments et boissons" : "Food & Beverage"}
                      </option>
                      <option value={"Forestry"}>
                        {langState === "fr" ? "Foresterie" : "Forestry"}
                      </option>
                      <option value={"Life Sciences & Health"}>
                        {langState === "fr" ? "Sciences de la vie et de la santé" : "Life Sciences & Health"}
                      </option>
                      <option value={"Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies"}>
                        {langState === "fr" ? "Exploitation minière, pétrole et gaz : Comprend les activités d’extraction qui ne relèveraient pas autrement des technologies propres" : "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies"}
                      </option>
                      <option value={"Tourism & Culture: Includes entertainment and sports"}>
                        {langState === "fr" ? "Culture et tourisme : comprend le divertissement et le sport" : "Tourism & Culture: Includes entertainment and sports"}
                      </option>
                      <option value={"Transportation"}>
                        {langState === "fr" ? "Transport" : "Transportation"}
                      </option>
                      <option value={"Other"}>
                        {langState === "fr" ? "Autre" : "Other"}
                      </option>
                    </select>
                  </div>
                </div>
                {requireIndusrtyOther &&                
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="industryOther">Industry (Other, please specify)</label>
                      {errorArray.includes("industryOther") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input type="text" id="industryOther" name="industryOther" 
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    value={companyInfoStateObj.industryOther || ""} onChange={handleCompanyInfoChangeString}></input>
                  </div>
                </div>
                }
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2 w-full">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="tech">Technology</label>
                      {errorArray.includes("tech") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="flex flex-wrap" id="tech">
                    {techOptions.map((item) => (
                      <div className="w-1/2" key={item.value}>
                        <div className="flex items-center my-2">
                          <input
                            type="checkbox"
                            checked={tech.includes(item.value)}
                            onChange={() => handleTechCheckboxChange(item.value)}
                            name={item.value}
                          />
                          <p className="ml-5">{item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {requireTechOther &&
                <div className="flex flex-col formComponentCont w-full">
                <div className="flex mb-2">
                  <div className="flex">
                    <label className="bodyLarger labelMargin" htmlFor="techOther">Tech (Other, please specify)</label>
                    {errorArray.includes("techOther") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="relative flex items-center">
                  <input type="text" id="techOther" name="techOther" 
                  className="w-full bodyLarger input !border-cSecondaryGreen border" 
                  value={companyInfoStateObj.techOther} onChange={handleCompanyInfoChangeString}></input>
                </div>
              </div>
                }
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="websiteURL">Website URL</label>
                      {errorArray.includes("websiteURL") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input type="text" id="websiteURL" placeholder="https://" name="websiteURL"
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    value={companyInfoStateObj.websiteURL} onChange={handleCompanyInfoChangeString}></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger labelMargin" htmlFor="linkedInURL">Company LinkedIn URL</label>
                      <p className="bodySmaller mb-2">Please only include an entry if it is a company LinkedIn page, no personal profiles are needed</p>
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input type="text" id="linkedInURL" placeholder="https://" name="linkedInURL"
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    value={companyInfoStateObj.linkedInURL || ""} onChange={handleCompanyInfoChangeString}></input>
                    {errorArray.includes("linkedInURL") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger labelMargin" htmlFor="numFullTimeEmployees">What is the number of full-time employees at your company globally?</label>
                      {errorArray.includes("numFullTimeEmployees") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input type="text" id="numFullTimeEmployees" name="numFullTimeEmployees"
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Enter numbers only"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                      ];
                      const isNumberKey = /^\d$/.test(e.key);
                      if (!isNumberKey && !allowedKeys.includes(e.key)) {
                        e.preventDefault(); // Prevent non-numeric keypresses
                      }
                    }}                  
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*$/.test(value)) {
                        handleCompanyInfoChangeString(e)
                      }
                    }}
                    value={companyInfoStateObj.numFullTimeEmployees} ></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger labelMargin" htmlFor="numFullTimeEmployeesCan">What is the number of full-time employees at your company in Canada?</label>
                      {errorArray.includes("numFullTimeEmployeesCan") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input
                      type="text"
                      id="numFullTimeEmployeesCan"
                      name="numFullTimeEmployeesCan"
                      className="w-full bodyLarger input !border-cSecondaryGreen border"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      placeholder="Enter numbers only"
                      value={companyInfoStateObj.numFullTimeEmployeesCan}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                        ];
                        const isNumberKey = /^\d$/.test(e.key);
                        if (!isNumberKey && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        handleCompanyInfoChangeString(e);
                      }}
                    />
                  </div>                
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger labelMargin" htmlFor="revenueOverTwelveMonths">Indicate your company’s total revenue (in $CAD) during your most recent fiscal year.</label>
                      {errorArray.includes("revenueOverTwelveMonths") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                <div className="relative flex items-center">
                    <input type="text" id="revenueOverTwelveMonths" name="revenueOverTwelveMonths"
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="$"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                      ];
                      const isNumberKey = /^\d$/.test(e.key);
                      if (!isNumberKey && !allowedKeys.includes(e.key)) {
                        e.preventDefault(); // Prevent non-numeric keypresses
                      }
                    }}                  
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*$/.test(value)) {
                        handleCompanyInfoChangeString(e)
                      }
                    }}             
                    value={companyInfoStateObj.revenueOverTwelveMonths} ></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex">
                    <span className="mb-2">Is your primary source of revenue (or intended source, if pre-revenue) derived from the technology being developed and not from services or consulting?</span>
                    {errorArray.includes("revFromTech") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                  <div className="flex gap-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={revFromTech === true}
                        onChange={() => setRevFromTech(true)}
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={revFromTech === false}
                        onChange={() => setRevFromTech(false)}
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="techReadiness">What is the Technology Readiness Level of your most mature product?</label>
                      {errorArray.includes("techReadiness") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <select id="techReadiness" name="techReadiness" 
                    className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                    value={companyInfoStateObj.techReadiness || ""} onChange={handleCompanyInfoChangeSelect}>
                      <option disabled value={""}>Please make a selection</option>
                      <option value={"trl1"}>
                        {langState === "fr" ? "TRL 1: Basic principles observed and reported" : "TRL 1: Basic principles observed and reported"}
                      </option>
                      <option value={"trl2"}>
                        {langState === "fr" ? "TRL 2: Technology concept and/or application formulated" : "TRL 2: Technology concept and/or application formulated"}
                      </option>
                      <option value={"trl3"}>
                        {langState === "fr" ? "TRL 3: Analytical and experimental proof of concept" : "TRL 3: Analytical and experimental proof of concept"}
                      </option>
                      <option value={"trl4"}>
                        {langState === "fr" ? "TRL 4: Component and/or validation in a laboratory environment" : "TRL 4: Component and/or validation in a laboratory environment"}
                      </option>
                      <option value={"trl5"}>
                        {langState === "fr" ? "TRL 5: Component and/or validation in a simulated environment" : "TRL 5: Component and/or validation in a simulated environment"}
                      </option>
                      <option value={"trl6"}>
                        {langState === "fr" ? "TRL 6: System/subsystem model or prototype demonstration in a simulated environment (i.e. prototype ready)" : "TRL 6: System/subsystem model or prototype demonstration in a simulated environment (i.e. prototype ready)"}
                      </option>
                      <option value={"trl7"}>
                        {langState === "fr" ? "TRL 7: Prototype ready for demonstration in an appropriate operational environment (i.e. MVP ready)" : "TRL 7: Prototype ready for demonstration in an appropriate operational environment (i.e. MVP ready)"}
                      </option>
                      <option value={"trl8"}>
                        {langState === "fr" ? "TRL 8: Actual technology completed and qualified through tests and demonstrations (i.e. pilots deployed)" : "TRL 8: Actual technology completed and qualified through tests and demonstrations (i.e. pilots deployed)"}
                      </option>
                      <option value={"trl9"}>
                        {langState === "fr" ? "TRL 9: Actual technology proven through successful deployment in an operational setting" : "TRL 9: Actual technology proven through successful deployment in an operational setting"}
                      </option>
                    </select>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger labelMargin" htmlFor="patentsGranted">How many patents (including industrial designs) have been granted to your company</label>
                      {errorArray.includes("patentsGranted") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <input type="text" id="patentsGranted" name="patentsGranted"
                      className="w-full bodyLarger input !border-cSecondaryGreen border" 
                      inputMode="numeric"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                        ];
                        const isNumberKey = /^\d$/.test(e.key);
                        if (!isNumberKey && !allowedKeys.includes(e.key)) {
                          e.preventDefault(); // Prevent non-numeric keypresses
                        }
                      }}                  
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || /^\d*$/.test(value)) {
                          handleCompanyInfoChangeString(e)
                        }
                      }}
                    value={companyInfoStateObj.patentsGranted} ></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger flex flex-col labelMargin" htmlFor="number">
                        <p>Your Canada Revenue Agency 9-Digit Business Number</p>
                        <p className="bodySmaller mb-2">The business number (BN), assigned to all incorporated businesses by the Canada Revenue Agency, is a 9-digit number that is unique to a business or legal entity. (Note: the BN is followed by a two-letter program identifier and a 4-digit reference number, both of which are unnecessary for this application). This number is different from the 7-digit Corporation Number and should not contain a hyphen.  If a valid 9-digit BN is not provided, the application will be rejected as it is a requirement for participation in ElevateIP.  For more details on what a BN is, visit <a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'>this website</a></p>
                      </label>
                      {errorArray.includes("number") &&
                        requiredFieldErrorMessage
                      }
                      {bnNotNine &&
                        <p className="flex items-center gap-1 ml-2 px-2 font-semibold text-cError " style={{opacity: "1", transform: "none"}}><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-exclamation" className="svg-inline--fa fa-circle-exclamation " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"></path></svg>Business number must be nine digits</p>
                      }
                    </div>
                  </div>
                    <div className="relative flex items-center">
                      <input type="text" id="number" name="number"
                        className="w-full bodyLarger input !border-cSecondaryGreen border" 
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                          ];
                          const isNumberKey = /^\d$/.test(e.key);
                          if (!isNumberKey && !allowedKeys.includes(e.key)) {
                            e.preventDefault(); // Prevent non-numeric keypresses
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length !== 9) {
                            setBnNotNine(true)
                          } else if (value.length === 9) {
                            setBnNotNine(false)
                          }
                          handleCompanyInfoChangeString(e)

                        }                    
                          }
                      value={companyInfoStateObj.number} ></input>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex flex-col">
                      <label className="bodyLarger flex flex-col labelMargin" htmlFor="date">
                        Registration Date
                      </label>
                      {errorArray.includes("date") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                      {datePickerHtml}
                    </div>
                 </div>
                 <div className="flex flex-col formComponentCont w-full">
                  <div className="flex">
                    <p className="mb-2">Is your company registered Federally?</p>
                      {errorArray.includes("registeredFederally") &&
                      <p className="mb-2">
                        {requiredFieldErrorMessage}
                        </p>
                      }
                    </div>
                  <div className="flex gap-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={federalRegistered === true}
                        onChange={() => setFederalRegistered(true)}
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={federalRegistered === false}
                        onChange={() => setFederalRegistered(false)}
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex">
                    <p className="mb-2">Is your company registered in any Provinces or Territories?</p>
                      {errorArray.includes("registeredProvincially") &&
                      <p className="mb-2">
                        {requiredFieldErrorMessage}
                        </p>
                      }
                  </div>
                  <div className="flex gap-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={provincialRegistered === true}
                        onChange={() => setProvincialRegistered(true)}
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={provincialRegistered === false}
                        onChange={() => setProvincialRegistered(false)}
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
                {provincialRegistered && 
                  <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2 w-full">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="province">Select Registered Provinces and Territories</label>
                    </div>
                    {errorArray.includes("province") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                  <div className="flex flex-wrap" id="province">
                    {provinceOptions.map((item) => (
                      <div className="w-1/2" key={item.value}>
                        <div className="flex items-center my-2">
                          <input
                            type="checkbox"
                            checked={province.includes(item.value)}
                            onChange={() => handleProvinceCheckboxChange(item.value)}
                            name={item.value}
                          />
                          <p className="ml-5">{langState === "fr" ? item.frText : item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                }
              </div>
              <div className="flex justify-evenly mt-6 w-full">
                <button type="button" className="primaryButton p-1 px-3 text-md" onClick={() => companyInfoErrorCheck()}>Save</button>
              </div>
            </div> 
          }
          {
            currentHTML === "pitchDeck" && 
            pitchDeckComplete === "incomplete" &&
            <div className="flex w-full">
              <div className="w-full flex-col flex">
                <h2 className="mb-4" >{textData.Pages.FounderPages.FounderProfile.Pitch[langState]}</h2>
                <h3 className="mb-10" >{textData.Pages.FounderPages.FounderProfile.PitchSub[langState]}</h3>
                  <div className="m-auto mb-10 w-full">
                    <p className="bodyLarger">{textData.Pages.FounderPages.FounderProfile.PitchUp[langState]}</p>
                    <p className="bodyLarger mb-10">{textData.Pages.FounderPages.FounderProfile.DocUp[langState]}</p>
                    <div className="flex flex-col gap-8">
                      <div className="">
                        <p className="font:semi-bold bodyLarger">{textData.Pages.FounderPages.FounderProfile.Req1Title[langState]}</p>
                        <ul className="ml-8 list-disc">
                          <li>{textData.Pages.FounderPages.FounderProfile.Req1List1[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req1List2[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req1List3[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req1List4[langState]}</li>
                        </ul>
                      </div>
                      <div className="">
                      <p className="font:semi-bold bodyLarger">{textData.Pages.FounderPages.FounderProfile.Req2Title[langState]}</p>
                        <ul className="ml-8 list-disc">
                          <li>{textData.Pages.FounderPages.FounderProfile.Req2List1[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req2List2[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req2List3[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req2List4[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req2List5[langState]}</li>
                        </ul>
                      </div>
                      <div className="">
                      <p className="font:semi-bold bodyLarger">{textData.Pages.FounderPages.FounderProfile.Req3Title[langState]}</p>
                        <ul className="ml-8 list-disc">
                          <li>{textData.Pages.FounderPages.FounderProfile.Req3List1[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req3List2[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req3List3[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req3List4[langState]}</li>
                          <li>{textData.Pages.FounderPages.FounderProfile.Req3List5[langState]}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="flex-col flex w-full">
                  <FileUpload handlePdfStateChange={handlePdfStateChange} />
                  {
                    pdfUploaded && pitchDeckComplete === "incomplete" &&
                    <div className="flex flex-wrap mt-2 gap-2 items-center">
                      <div className="successCircle ">
                        <svg  xmlns="http://www.w3.org/2000/svg" width="10px" height="9px" viewBox="0 0 8 7" fill="#4F9D7A"><path d="M1 3.63333L2.90909 5.5L7 1.5" stroke="#4F9D7A" strokeWidth="2" strokeLinecap="round"/></svg>
                      </div>
                      <p>{textData.Pages.FounderPages.FounderProfile.NewSuccess[langState]}</p>
                    </div>
                  }
                  <div className="w-full m-auto flex mt-5">
                    <Button 
                      buttonText="Save"
                      actionHandler={pdfSave}
                      disabled={!pdfUploaded}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          {currentHTML === "pitchDeck" && pitchDeckComplete === "complete" &&
            <div className="w-full h-full flex-col flex gap-8 items-center justify-center">
                <h3 className="">{textData.Pages.FounderPages.FounderProfile.Pitch[langState]}</h3>
                <h4 className="">Pitch Deck has been received!</h4> 
                <button onClick={() => setPitchDeckComplete("incomplete")} className="bodyLarger underline">Upload New Pitch Deck</button>

                <Button 
                  buttonText="Next"
                  actionHandler={() => setCurrentHTML("needHelpWith")}
                />
            </div>
          }
          {
            currentHTML === "needHelpWith" &&
            <div className="flex flex-col">
              <h3 className="mb-8">{textData.Pages.FounderPages.FounderProfile.HelpWith[langState]}</h3>
              <div className="flex flex-col">
                <div className="flex flex-col formComponentCont w-full">
                  <p className="mb-2">At this time, for this application, I'm seeking General IP Education (e.g. where do I start? What is a patent?, etc.)</p>
                  <div className="mb-2">
                  {errorArray.includes("seekingEducation") &&
                    requiredFieldErrorMessage
                  }
                  </div>
                  <div className="flex gap-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={seekingEducation === true}
                        onChange={() => setSeekingEducation(true)}
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={seekingEducation === false}
                        onChange={() => setSeekingEducation(false)}
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex flex-col formComponentCont w-full">
                <div>
                  <p className="mb-2">At this time, for this application, I'd like to meet with an Elevate IP Advisor to get guidance on how I can use IP to help reach my business goals.</p>
                  <div className="mb-2">
                  {errorArray.includes("businessGoal") &&
                    requiredFieldErrorMessage
                  }
                  </div>
                </div>
                <div className="flex gap-4">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={businessGoal === true}
                      onChange={() => setBusinessGoal(true)}
                    />
                    <span className="ml-2">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={businessGoal === false}
                      onChange={() => setBusinessGoal(false)}
                    />
                    <span className="ml-2">No</span>
                  </label>
                </div>
              </div>
              {businessGoal &&
              <div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2 w-full">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="topics">Please select the topics that you'd like to discuss with our IP Advisor:</label>
                      {errorArray.includes("topics") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="flex flex-wrap" id="topics">
                    {topicsOptions.map((item) => (
                      <div className="w-1/2" key={item.value}>
                        <div className="flex items-center my-2">
                          <input
                            type="checkbox"
                            checked={topics.includes(item.value)}
                            onChange={() => handleTopicsCheckboxChange(item.value)}
                            name={item.value}
                          />
                          <p className="ml-5">{item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="specificDiscussion">Without specifically referencing IP sensitive information, please provide a general overview of what you' like to discuss with our IP Advisor</label>
                      {errorArray.includes("specificDiscussion") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="relative flex items-center">
                    <textarea placeholder="" id="specificDiscussion" name="specificDiscussion" 
                    className="w-full bodyLarger input !border-cSecondaryGreen border" 
                    value={needHelpWithStateObj.specificDiscussion} onChange={handleNeedHelpWithChange}></textarea>
                  </div>
                </div>
              </div>
            }
              <div className="flex flex-col formComponentCont w-full">
                <div>
                  <p className="mb-2">Have you and your cofounders signed a "Co-founders IP assignment agreement" that assigns IP to the corporation?</p>
                  <div className="mb-2">
                  {errorArray.includes("agreementSigned") &&
                    requiredFieldErrorMessage
                  }
                  </div>
                </div>
                <div className="flex gap-4">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={agreementSigned === true}
                      onChange={() => setAgreementSigned(true)}
                    />
                    <span className="ml-2">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={agreementSigned === false}
                      onChange={() => setAgreementSigned(false)}
                    />
                    <span className="ml-2">No</span>
                  </label>
                </div>
              </div>
                <div className="flex flex-col formComponentCont w-full">
                  <div className="flex mb-2 w-full">
                    <div className="flex">
                      <label className="bodyLarger labelMargin" htmlFor="desiredActivities">At this time, for this application, I'd like help with IP Service Provider costs for the following activities:</label>
                      {errorArray.includes("desiredActivities") &&
                        requiredFieldErrorMessage
                      }
                    </div>
                  </div>
                  <div className="flex flex-wrap" id="desiredActivities">
                    {desiredActivitiesOptions.map((item) => (
                      <div className="w-1/2" key={item.value}>
                        <div className="flex items-center my-2">
                          <input
                            type="checkbox"
                            checked={desiredActivities.includes(item.value)}
                            onChange={() => handleDesiredActivitesCheckboxChange(item.value)}
                            name={item.value}
                          />
                          <p className="ml-5">{item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {
                requireDesiredActivitesOther &&
                <div className="flex flex-col formComponentCont w-full">
                <div className="flex mb-2">
                  <div className="flex flex-col">
                    <label className="bodyLarger labelMargin" htmlFor="activitiesOther">Please specify</label>
                    {errorArray.includes("activitiesOther") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="relative flex items-center">
                  <input type="text" id="activitiesOther" name="activitiesOther"
                  className="w-full bodyLarger input !border-cSecondaryGreen border" 
                  value={needHelpWithStateObj.activitiesOther} onChange={handleNeedHelpWithChange}></input>
                </div>
              </div>
              }
              <div className="flex flex-col formComponentCont w-full">
                <div className="flex mb-2 w-full">
                  <div className="flex">
                    <label className="bodyLarger labelMargin" htmlFor="patentActivities">At this time, for this application, I'd like help with IP Service Provider costs for the following activities:</label>
                    {errorArray.includes("patentActivities") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="flex flex-wrap" id="patentActivities">
                  {patentActivitiesOptions.map((item) => (
                    <div className="w-1/2" key={item.value}>
                      <div className="flex items-center my-2">
                        <input
                          type="checkbox"
                          checked={patentActivities.includes(item.value)}
                          onChange={() => handlePatentActivitesCheckboxChange(item.value)}
                          name={item.value}
                        />
                        <p className="ml-5">{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {
              requirePatentActivitiesOther &&
              <div className="flex flex-col formComponentCont w-full">
                <div className="flex mb-2">
                  <div className="flex flex-col">
                    <label className="bodyLarger labelMargin" htmlFor="patentActivitiesOther">Please specify</label>
                    {errorArray.includes("patentActivitiesOther") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="relative flex items-center">
                  <input type="text" id="patentActivitiesOther" name="patentActivitiesOther"
                  className="w-full bodyLarger input !border-cSecondaryGreen border" 
                  value={needHelpWithStateObj.patentActivitiesOther} onChange={handleNeedHelpWithChange}></input>
                </div>
              </div>
            }
            {patentActivities.includes("Trademark Filing") &&
            <div className="flex flex-col formComponentCont w-full">
              <div className="flex mb-2">
                <div className="flex">
                  <label className="bodyLarger labelMargin" htmlFor="searchCompleted">If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?</label>
                  {errorArray.includes("searchCompleted") &&
                    requiredFieldErrorMessage
                  }
                </div>
              </div>
              <div className="relative flex items-center">
                <select id="searchCompleted" name="searchCompleted" 
                className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                value={needHelpWithStateObj.searchCompleted || ""} onChange={handleNeedHelpWithChange}>
                  <option disabled value={""}>Please make a selection</option>
                  <option value={"Yes"}>
                    {langState === "fr" ? "Oui" : "Yes"}
                  </option>
                  <option value={"no"}>
                    {langState === "fr" ? "Non" : "No"}
                  </option>
                  <option value={"n/a"}>
                    {langState === "fr" ? "N/A" : "N/A"}
                  </option>
                </select>
                </div>
              </div>
            }
            {patentActivities.length > 0 &&
            <div className="flex flex-col formComponentCont w-full">
              <div className="flex mb-2">
                <div className="flex">
                  <label className="bodyLarger labelMargin" htmlFor="exclusiveRights">If the ownership of your IP is shared (e.g. with an academic institution), do you have exclusive rights to commercialize the technology?</label>
                  {errorArray.includes("exclusiveRights") &&
                    requiredFieldErrorMessage
                  }
                </div>
              </div>
              <div className="relative flex items-center">
                <select id="exclusiveRights" name="exclusiveRights" 
                className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                value={needHelpWithStateObj.exclusiveRights || ""} onChange={handleNeedHelpWithChange}>
                  <option disabled value={""}>Please make a selection</option>
                  <option value={"Yes"}>
                    {langState === "fr" ? "Oui" : "Yes"}
                  </option>
                  <option value={"no"}>
                    {langState === "fr" ? "Non" : "No"}
                  </option>
                  <option value={"n/a"}>
                    {langState === "fr" ? "N/A" : "N/A"}
                  </option>
                </select>
                </div>
              </div>
            }
            {patentActivities.includes("Patent Filing") &&
              <div className="flex flex-col formComponentCont w-full">
              <div className="flex mb-2 w-full">
                <div className="flex">
                  <label className="bodyLarger labelMargin" htmlFor="patentsReadyOptions">If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:</label>
                  {errorArray.includes("patentsReadyOptions") &&
                    requiredFieldErrorMessage
                  }
                </div>
              </div>
              <div className="flex flex-wrap" id="patentsReadyOptions">
                {patentsReadyOptionsOptions.map((item) => (
                  <div className="w-1/2" key={item.value}>
                    <div className="flex items-center my-2">
                      <input
                        type="checkbox"
                        checked={patentsReadyOptions.includes(item.value)}
                        onChange={() => handlePatentsReadyOptionsCheckboxChange(item.value)}
                        name={item.value}
                      />
                      <p className="ml-5">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
            <div className="flex flex-col formComponentCont w-full">
              <p className="mb-2">Is your company currently working with an IP / Law firm that you intend to use for the support being sought from the ElevateIP program?</p>
              <div className="mb-2">
                {errorArray.includes("workingWithFirm") &&
                  requiredFieldErrorMessage
                }
              </div>
              <div className="flex gap-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={workingWithFirm === true}
                    onChange={() => setWorkingWithFirm(true)}
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={workingWithFirm === false}
                    onChange={() => setWorkingWithFirm(false)}
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>
            {workingWithFirm &&
            <div className="flex flex-col formComponentCont w-full">
              <div className="flex mb-2">
                <div className="flex">
                  <label className="bodyLarger labelMargin" htmlFor="firmId">Please select the firm (select "Other" if your current firm is not listed)</label>
                  <p className="my-1">Please note: Not all listed service providers are onboarded with every delivery partner. If your chosen provider requires additional onboarding, we'll contact both you and the provider</p>
                  {errorArray.includes("firmId") &&
                    requiredFieldErrorMessage
                  }
                </div>
              </div>
              <div className="relative flex items-center">
                <select id="firmId" name="firmId" 
                className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                value={needHelpWithStateObj.firmId || ""} defaultValue={""} onChange={handleNeedHelpWithChange}>
                  <option disabled value={""}>Please make a selection</option>
                  {regionalFirmOptions.map((item) => (
                    <option value={item.value}>
                      {langState === "fr" ? item.frText : item.text }
                    </option>
                  ))}
                <option value={"Other"}>{langState === "fr" ? "Autre" : "Other" }</option>
                </select>
              </div>
            </div>
            }
            {
            requireFirmOther &&
              <div className="flex flex-col formComponentCont w-full">
                <div className="flex mb-2">
                  <div className="flex flex-col">
                    <label className="bodyLarger labelMargin" htmlFor="firmOther">Please specify</label>
                    {errorArray.includes("firmOther") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="relative flex items-center">
                  <input type="text" id="firmOther" name="firmOther"
                  className="w-full bodyLarger input !border-cSecondaryGreen border" 
                  value={needHelpWithStateObj.firmOther} onChange={handleNeedHelpWithChange}></input>
                </div>
              </div>
            }
            <div className="flex flex-col formComponentCont w-full">
              <p className="mb-2">Is your company currently or in the last 24 months received government funded support related to Intellectual Property?</p>
              <div className="mb-2">
              {errorArray.includes("govtSupport") &&
                requiredFieldErrorMessage
              }
              </div>
              <div className="flex gap-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={govtSupport === true}
                    onChange={() => setGovtSupport(true)}
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={govtSupport === false}
                    onChange={() => setGovtSupport(false)}
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>
            {
              govtSupport &&
            <div className="flex flex-col formComponentCont w-full">
              <div className="flex mb-2">
                <div className="flex">
                  <label className="bodyLarger labelMargin" htmlFor="supportOrg">Please select which organization:</label>
                  {errorArray.includes("supportOrg") &&
                    requiredFieldErrorMessage
                  }
                </div>
              </div>
              <div className="relative flex items-center">
                <select id="supportOrg" name="supportOrg" 
                className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                value={needHelpWithStateObj.supportOrg || ""} onChange={handleNeedHelpWithChange}>
                  <option disabled value={""}>Please make a selection</option>
                  <option value={"Intellectual Property Ontario (IPON)"}>
                    Intellectual Property Ontario (IPON)
                  </option>
                  <option value={"IP Assist"}>
                    IP Assist
                  </option>
                  <option value={"Other"}>
                    Other
                  </option>
                </select>
              </div>
            </div>
            }
            {
              requireSupportOrgOther &&
              <div className="flex flex-col formComponentCont w-full">
                <div className="flex mb-2">
                  <div className="flex flex-col">
                    <label className="bodyLarger labelMargin" htmlFor="supportOrgOther">Please specify</label>
                    {errorArray.includes("supportOrgOther") &&
                      requiredFieldErrorMessage
                    }
                  </div>
                </div>
                <div className="relative flex items-center">
                  <input type="text" id="supportOrgOther" name="supportOrgOther"
                  className="w-full bodyLarger input !border-cSecondaryGreen border" 
                  value={needHelpWithStateObj.supportOrgOther} onChange={handleNeedHelpWithChange}></input>
                </div>
              </div>
            }
            <div className="flex justify-evenly mt-6 w-full">
              <button type="button" className="primaryButton p-1 px-3 text-md" onClick={() => needHelpWithErrorCheck()}>Save</button>
            </div>
          </div>
          }
          {
            currentHTML === "programingEvaluation" &&
            <div className="flex flex-col">
              <h3 className="mb-8">{textData.Pages.FounderPages.FounderProfile.ServiceEval[langState]}</h3>
              <Form
                formDefinition={profileFormProgramingEvaluationDefinition}
                formData={programingEvaluation}
                primaryButtonProp={saveSectionButtonProp}
              />
            </div>
          }
          {
            currentHTML === "review" &&
            reviewHtml
          }
          </div>
      </div>
      <Modal 
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        modalHeader={""}
        contentLabel={textData.Pages.FounderPages.FounderProfile.AttestatioLabel[langState]}
        primaryButton={{ buttonText: "Confirm", buttonCallback: () => isAttestaionChecked ? handleSubmitMembershipApplication() : attestaionPrompt() }}
        modalHTML={modalHTML}
      />
    </div>
  )
}

export default FounderProfileUpdated;